/* eslint-disable */
import { DocumentTypeDecoration } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any };
};

export type AccessRecord = {
  __typename?: "AccessRecord";
  accessedBy: Scalars["String"]["output"];
  account?: Maybe<Account>;
  createdOn: Scalars["DateTime"]["output"];
  id: Scalars["Int"]["output"];
  source: Scalars["String"]["output"];
  updatedOn: Scalars["DateTime"]["output"];
};

export type AccessRecordsQuery = {
  accessedBy?: InputMaybe<Scalars["String"]["input"]>;
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type Account = {
  __typename?: "Account";
  Id_Ehr?: Maybe<Scalars["String"]["output"]>;
  activityPhoneNumber?: Maybe<Scalars["String"]["output"]>;
  bdlProgramEndOn?: Maybe<Scalars["DateTime"]["output"]>;
  bdlProgramStartOn?: Maybe<Scalars["DateTime"]["output"]>;
  /** Call plans for the account. */
  callPlans: Array<CallPlan>;
  callRecords?: Maybe<Array<CallRecord>>;
  callSchedules?: Maybe<Array<CallSchedule>>;
  contactPhoneNumber?: Maybe<Scalars["String"]["output"]>;
  createdOn: Scalars["DateTime"]["output"];
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  firstName: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  lastScamWarning?: Maybe<Scalars["DateTime"]["output"]>;
  latestProgram?: Maybe<ProgramHistory>;
  latest_program_type?: Maybe<Scalars["String"]["output"]>;
  latest_program_type_status?: Maybe<Scalars["String"]["output"]>;
  leadType?: Maybe<Scalars["String"]["output"]>;
  nextScheduledCall?: Maybe<Scalars["DateTime"]["output"]>;
  playlists?: Maybe<Array<Playlist>>;
  profilePhotoUrl?: Maybe<Scalars["String"]["output"]>;
  programEndOn?: Maybe<Scalars["DateTime"]["output"]>;
  programStartOn?: Maybe<Scalars["DateTime"]["output"]>;
  programs?: Maybe<Array<ProgramHistory>>;
  specialist?: Maybe<User>;
  summary?: Maybe<Scalars["String"]["output"]>;
  timeZone?: Maybe<Scalars["String"]["output"]>;
  updatedOn: Scalars["DateTime"]["output"];
  user?: Maybe<User>;
};

export type Activity = {
  __typename?: "Activity";
  /** The type of the activity. */
  activityTypes: Array<ActivityType>;
  /** The category of the activity. */
  category: ActivityCategory;
  /** Cognitive domains associated with this activity (from its activity type). */
  cognitiveDomains?: Maybe<Array<ActivityCognitiveDomain>>;
  /** Instructions and questions in order of presentation. */
  contents: Array<ActivityContent>;
  createdAt: Scalars["DateTime"]["output"];
  /** The user who created the activity. */
  createdBy: User;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The description of the activity. */
  description: Scalars["String"]["output"];
  /** The difficulty of the activity. */
  difficulty: ActivityDifficulty;
  /** The call plan with the smallest program week for this account that includes this activity and has a start date strictly after the current time. */
  earliestFutureCallPlan?: Maybe<CallPlan>;
  /** Estimated duration in seconds. */
  estimatedDuration?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["Int"]["output"];
  /** Timestamp of the last delivery of this activity. */
  lastDeliveryTime?: Maybe<Scalars["DateTime"]["output"]>;
  /** The title of the activity. */
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  /** The optional pre-recorded voice message for the activity. */
  voiceMessage?: Maybe<VoiceMessage>;
};

export type ActivityEarliestFutureCallPlanArgs = {
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ActivityLastDeliveryTimeArgs = {
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum ActivityCategory {
  CognitiveExercise = "COGNITIVE_EXERCISE",
  CompensatoryStrategy = "COMPENSATORY_STRATEGY",
  LifestyleChanges = "LIFESTYLE_CHANGES",
}

export type ActivityCognitiveDomain = {
  __typename?: "ActivityCognitiveDomain";
  /** Activity types for this cognitive domain. */
  activityTypes: Array<ActivityType>;
  /** Unique key for the cognitive domain. */
  domainKey: Scalars["String"]["output"];
  /** Human readable label of the cognitive domain. */
  domainLabel: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
};

/** A single ordered step in an activity: instruction text or an interactive question. */
export type ActivityContent = {
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["Int"]["output"];
  /** Text read to the user. */
  readableText: Scalars["String"]["output"];
  /** Playback order within the activity. */
  sequenceOrder: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export enum ActivityDifficulty {
  Easy = "EASY",
  Hard = "HARD",
  Medium = "MEDIUM",
}

export type ActivityInteraction = Interaction & {
  __typename?: "ActivityInteraction";
  /** The ID of the activity. */
  activityId?: Maybe<Scalars["Int"]["output"]>;
  /** The type of the activity. */
  activityTypes: Array<ActivityType>;
  /** The category of the activity. */
  category: ActivityCategory;
  /** Cognitive domains associated with this activity (from its activity type). */
  cognitiveDomains?: Maybe<Array<ActivityCognitiveDomain>>;
  /** Instructions and questions in order of presentation. */
  contents: Array<ActivityContent>;
  createdAt: Scalars["DateTime"]["output"];
  /** The user who created the activity. */
  createdBy: User;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The description of the activity. */
  description: Scalars["String"]["output"];
  /** The difficulty of the activity. */
  difficulty: ActivityDifficulty;
  /** Estimated duration in seconds. */
  estimatedDuration?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["Int"]["output"];
  /** The sequence number of this interaction within the call plan. */
  order: Scalars["Int"]["output"];
  /** Whether user can skip to the next interaction. */
  skippable: Scalars["Boolean"]["output"];
  /** The title of the activity. */
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  /** The optional pre-recorded voice message for the activity. */
  voiceMessage?: Maybe<VoiceMessage>;
};

export type ActivityListFiltersInput = {
  categories?: InputMaybe<Array<ActivityCategory>>;
  contentSearch?: InputMaybe<Scalars["String"]["input"]>;
  difficulties?: InputMaybe<Array<ActivityDifficulty>>;
  domainKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
  titleSearch?: InputMaybe<Scalars["String"]["input"]>;
  typeKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ActivityListSortInput = {
  direction: ActivitySortOrder;
  /** Single column to sort by. */
  fieldName: ActivitySortField;
};

export type ActivityQuestionType = {
  __typename?: "ActivityQuestionType";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["Int"]["output"];
  /** Detailed description of the question type. */
  questionTypeDescription: Scalars["String"]["output"];
  /** Unique key for the question type. */
  questionTypeKey: Scalars["String"]["output"];
  /** Human readable label of the question type. */
  questionTypeLabel: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type ActivityRecord = {
  __typename?: "ActivityRecord";
  callRecord: CallRecord;
  callSid: Scalars["String"]["output"];
  durationInSeconds?: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["Float"]["output"];
  isCompleted: Scalars["Boolean"]["output"];
  startedAt: Scalars["DateTime"]["output"];
  stoppedAt: Scalars["DateTime"]["output"];
  voiceMessage: VoiceMessage;
};

export enum ActivitySortField {
  Category = "CATEGORY",
  Difficulty = "DIFFICULTY",
  Title = "TITLE",
}

export enum ActivitySortOrder {
  Asc = "ASC",
  Desc = "DESC",
}

export type ActivityType = {
  __typename?: "ActivityType";
  /** Unique key for the activity type. */
  activityTypeKey: Scalars["String"]["output"];
  /** Human readable label of the activity type. */
  activityTypeLabel: Scalars["String"]["output"];
  /** Cognitive domains for this activity type. */
  cognitiveDomains?: Maybe<Array<ActivityCognitiveDomain>>;
  /** The order in which the activity type is to be displayed. */
  displayOrder: Scalars["Int"]["output"];
  id: Scalars["Int"]["output"];
};

export type AudioFile = {
  __typename?: "AudioFile";
  callSid?: Maybe<Scalars["String"]["output"]>;
  createdOn: Scalars["DateTime"]["output"];
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  durationInSeconds?: Maybe<Scalars["Int"]["output"]>;
  filename: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  updatedOn: Scalars["DateTime"]["output"];
};

export type AuthMfaTokenInput = {
  method: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type AuthSession = {
  __typename?: "AuthSession";
  accessToken: Scalars["String"]["output"];
  expiration: Scalars["Float"]["output"];
  idToken: Scalars["String"]["output"];
  isValid: Scalars["Boolean"]["output"];
  lastPass?: Maybe<Scalars["String"]["output"]>;
  refreshToken: Scalars["String"]["output"];
};

export type CallDurationQuery = {
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum CallFlowVersion {
  V1 = "V1",
  V2 = "V2",
}

export enum CallOutcome {
  Failure = "FAILURE",
  InProgress = "IN_PROGRESS",
  Success = "SUCCESS",
}

export type CallPlan = {
  __typename?: "CallPlan";
  createdAt: Scalars["DateTime"]["output"];
  /** The date this call plan expires. */
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["Int"]["output"];
  /** Ordered interactions in this call plan. */
  interactions?: Maybe<Array<Interaction>>;
  /** Whether this call plan is currently active. */
  isActive: Scalars["Boolean"]["output"];
  /** The program this call plan belongs to. */
  program: ProgramHistory;
  /** The week of the program this call plan belongs to. */
  programWeek: Scalars["Int"]["output"];
  /** The date this call plan becomes active. */
  startDate: Scalars["DateTime"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type CallRecord = {
  __typename?: "CallRecord";
  account?: Maybe<Account>;
  activities?: Maybe<Array<ActivityRecord>>;
  activityDifficulty?: Maybe<Scalars["String"]["output"]>;
  awsUrl?: Maybe<Scalars["String"]["output"]>;
  createdOn: Scalars["DateTime"]["output"];
  deliveredCallPlanId?: Maybe<Scalars["Int"]["output"]>;
  durationInSeconds?: Maybe<Scalars["Int"]["output"]>;
  errorDetails?: Maybe<Scalars["String"]["output"]>;
  fullPerformanceRatingResponse?: Maybe<Scalars["String"]["output"]>;
  fullProgramRatingResponse?: Maybe<Scalars["String"]["output"]>;
  hangupDetails?: Maybe<Scalars["String"]["output"]>;
  hbacalldata?: Maybe<Array<Scalars["String"]["output"]>>;
  outcome: CallOutcome;
  performanceRating?: Maybe<Scalars["Int"]["output"]>;
  performanceReason?: Maybe<Scalars["String"]["output"]>;
  playlist?: Maybe<Playlist>;
  programRating?: Maybe<Scalars["Int"]["output"]>;
  recordingDownloadUrl?: Maybe<Scalars["String"]["output"]>;
  reflectionOnLearnings?: Maybe<Scalars["String"]["output"]>;
  sessionCount?: Maybe<Scalars["Int"]["output"]>;
  sid: Scalars["String"]["output"];
  type: CallType;
  updatedOn: Scalars["DateTime"]["output"];
  user?: Maybe<User>;
};

export type CallRecordsQuery = {
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
  hbacalldata?: InputMaybe<Array<Scalars["String"]["input"]>>;
  minDuration?: InputMaybe<Scalars["Int"]["input"]>;
  playlistId?: InputMaybe<Scalars["Int"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  sortDirection?: InputMaybe<SortingDirection>;
  take?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CallSchedule = {
  __typename?: "CallSchedule";
  account?: Maybe<Account>;
  callFlowVersion: CallFlowVersion;
  createdOn: Scalars["DateTime"]["output"];
  cronExpression: Scalars["String"]["output"];
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["Int"]["output"];
  scheduleDescription: Scalars["String"]["output"];
  updatedOn: Scalars["DateTime"]["output"];
};

export enum CallType {
  InboundCallBdl = "INBOUND_CALL_BDL",
  InboundCallV2 = "INBOUND_CALL_V2",
  InboundCallV3 = "INBOUND_CALL_V3",
  OutboundCallBdl = "OUTBOUND_CALL_BDL",
  OutboundCallV2 = "OUTBOUND_CALL_V2",
  OutboundCallV3 = "OUTBOUND_CALL_V3",
  OutboundFollowUp = "OUTBOUND_FOLLOW_UP",
  OutboundInitial = "OUTBOUND_INITIAL",
}

export type ChangePass = {
  __typename?: "ChangePass";
  done: Scalars["Boolean"]["output"];
};

export enum CognitiveDomain {
  AttentionAndConcentration = "AttentionAndConcentration",
  AuditoryProcessing = "AuditoryProcessing",
  ClientReflection = "ClientReflection",
  ExpressiveLanguage = "ExpressiveLanguage",
  Intro = "Intro",
  LongTermMemory = "LongTermMemory",
  Outro = "Outro",
  PlanningAndOrganization = "PlanningAndOrganization",
  ProblemSolving = "ProblemSolving",
  ProceduralMemory = "ProceduralMemory",
  ReasoningLogic = "ReasoningLogic",
  ReceptiveLanguage = "ReceptiveLanguage",
  RecordingFeedback = "RecordingFeedback",
  ShortTermMemory = "ShortTermMemory",
  ThoughtOrganization = "ThoughtOrganization",
  Transition = "Transition",
}

export enum CognitiveLevel {
  High = "High",
  Low = "Low",
  Medium = "Medium",
}

export enum ContentType {
  Instruction = "INSTRUCTION",
  Question = "QUESTION",
}

export type CreateAccessRecordDto = {
  accessedBy: Scalars["String"]["input"];
  accountId: Scalars["Int"]["input"];
  source: Scalars["String"]["input"];
};

export type CreateCallPlanInput = {
  accountId: Scalars["Int"]["input"];
  /** The activities to include in this call plan, in order. */
  activityIds: Array<Scalars["Int"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  programWeek?: InputMaybe<Scalars["Int"]["input"]>;
  startDate: Scalars["String"]["input"];
};

export type CreateCallScheduleDto = {
  accountId: Scalars["Int"]["input"];
  callFlowVersion?: InputMaybe<CallFlowVersion>;
  cronExpression: Scalars["String"]["input"];
  timeZone?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreatePlaylistDto = {
  accountId: Scalars["Int"]["input"];
  endOn: Scalars["String"]["input"];
  isFreeTrial?: InputMaybe<Scalars["Boolean"]["input"]>;
  isInbound?: InputMaybe<Scalars["Boolean"]["input"]>;
  isOutbound?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTracked?: InputMaybe<Scalars["Boolean"]["input"]>;
  startOn: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
  voiceMessageIds: Array<Scalars["Int"]["input"]>;
};

export type DeactivateVoiceMessageDto = {
  deactivationNote?: InputMaybe<Scalars["String"]["input"]>;
};

export type DeactivatedAccountsResponse = {
  __typename?: "DeactivatedAccountsResponse";
  deactivatedAccounts: Array<Account>;
  totalDeactivatedCount: Scalars["Int"]["output"];
};

export enum Difficulty {
  Easy = "Easy",
  Hard = "Hard",
  Medium = "Medium",
}

export enum DifficultyType {
  Easy = "EASY",
  Hard = "HARD",
  Medium = "MEDIUM",
}

export type DraftActivity = {
  __typename?: "DraftActivity";
  /** Serialized activity payload while in draft. */
  activityJSON: Scalars["JSONObject"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["Int"]["output"];
  /** Draft title; unique across draft activities. */
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type ExpectedAnswer = {
  __typename?: "ExpectedAnswer";
  /** The text of the expected answer. */
  expectedAnswerText: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
};

export type ExpireRefreshTokenInput = {
  userId: Scalars["String"]["input"];
};

export type ExpireRefreshTokenResponse = {
  __typename?: "ExpireRefreshTokenResponse";
  done: Scalars["Boolean"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
};

export enum Feature {
  CompensatoryStrategies = "CompensatoryStrategies",
  HealthyBrainActivity = "HealthyBrainActivity",
  Instructions = "Instructions",
  Lifestyle = "Lifestyle",
}

export type FeatureStatus = {
  __typename?: "FeatureStatus";
  enabled: Scalars["Boolean"]["output"];
  featureName: Scalars["String"]["output"];
  treatment: Scalars["String"]["output"];
};

export type Feedback = {
  __typename?: "Feedback";
  callRecord: CallRecord;
  callSid: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  createdBy: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
  rating: Scalars["Int"]["output"];
  reason?: Maybe<Array<Scalars["String"]["output"]>>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type GetTranscribeReturn = {
  __typename?: "GetTranscribeReturn";
  code: Scalars["Float"]["output"];
  data?: Maybe<Scalars["JSONObject"]["output"]>;
  message: Scalars["String"]["output"];
};

export type InstructionActivityContent = ActivityContent & {
  __typename?: "InstructionActivityContent";
  /** The type of content. */
  contentType: ContentType;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["Int"]["output"];
  /** Text read to the user. */
  readableText: Scalars["String"]["output"];
  /** Playback order within the activity. */
  sequenceOrder: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

/** Columns from the interaction row shared by all variants returned on CallPlan.interactions. */
export type Interaction = {
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["Int"]["output"];
  /** The sequence number of this interaction within the call plan. */
  order: Scalars["Int"]["output"];
  /** Whether user can skip to the next interaction. */
  skippable: Scalars["Boolean"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export enum InteractionType {
  Activity = "ACTIVITY",
  Greeting = "GREETING",
  Intro = "INTRO",
  Outro = "OUTRO",
  QuietEnvironmentReminder = "QUIET_ENVIRONMENT_REMINDER",
  Recap = "RECAP",
  RedoInstructions = "REDO_INSTRUCTIONS",
  ScamWarning = "SCAM_WARNING",
  Survey = "SURVEY",
  Transition = "TRANSITION",
}

export type LoginRequestDto = {
  password: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
};

export type MfaSession = {
  __typename?: "MFASession";
  done: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
};

export type Mutation = {
  __typename?: "Mutation";
  approveVoiceMessage: VoiceMessage;
  changePassword: ChangePass;
  createAccessRecord: AccessRecord;
  createAccount: Account;
  /** Create a call plan for a program week with up to three activity steps. */
  createCallPlan: CallPlan;
  createCallSchedule: CallSchedule;
  createFeedback: Feedback;
  createPlaylist: Playlist;
  createProgramHistory: ProgramHistory;
  deactivateAccount: Account;
  /** Delete a call plan that has not begun (UTC calendar day). Removes its interactions; fails if deliveries exist. */
  deleteCallPlan: Scalars["Boolean"]["output"];
  deleteCallSchedule: CallSchedule;
  deletePlaylist: Playlist;
  expireRefreshToken: ExpireRefreshTokenResponse;
  getOtp: MfaSession;
  login: AuthSession;
  reactivateAccount: Account;
  refreshToken: AuthSession;
  resetAccountLock: ResetAccountLockSession;
  restoreCallSchedule: CallSchedule;
  restorePlaylist: Playlist;
  setVoiceMessageActivation: VoiceMessage;
  updateAccount: Account;
  /** Update an existing call plan. */
  updateCallPlan: CallPlan;
  updateCallRecord: CallRecord;
  updateCallSchedule: CallSchedule;
  updateFeedback: Feedback;
  updateHealthieForm: Scalars["JSONObject"]["output"];
  updatePhoneNumber: UpdateUserPhoneNumberSession;
  updatePlaylist: Playlist;
  updateProgramHistory: ProgramHistory;
  updateSessionCount: CallRecord;
  updateUser: User;
  updateUserNotificationPreferences: NotificationPreference;
  updateVoiceMessage: VoiceMessage;
  uploadVoiceMessage: VoiceMessage;
  /** Create or update a draft. Pass `id` to update; omit `id` to create. `activityJSON` must include string `title` (synced to the unique title column). */
  upsertDraftActivity: DraftActivity;
  verifyOtp: VerifyMfaSession;
};

export type MutationApproveVoiceMessageArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationChangePasswordArgs = {
  data: ChangePasswordInput;
};

export type MutationCreateAccessRecordArgs = {
  data: CreateAccessRecordDto;
};

export type MutationCreateAccountArgs = {
  data: OnboardSimpleDto;
};

export type MutationCreateCallPlanArgs = {
  input: CreateCallPlanInput;
};

export type MutationCreateCallScheduleArgs = {
  data: CreateCallScheduleDto;
};

export type MutationCreateFeedbackArgs = {
  data: CreateFeedbackDto;
};

export type MutationCreatePlaylistArgs = {
  data: CreatePlaylistDto;
};

export type MutationCreateProgramHistoryArgs = {
  data: ProgramHistoryDto;
};

export type MutationDeactivateAccountArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationDeleteCallPlanArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationDeleteCallScheduleArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationDeletePlaylistArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationExpireRefreshTokenArgs = {
  data: ExpireRefreshTokenInput;
};

export type MutationGetOtpArgs = {
  data: AuthMfaTokenInput;
};

export type MutationLoginArgs = {
  data: LoginRequestDto;
};

export type MutationReactivateAccountArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationRefreshTokenArgs = {
  data: RefreshTokenInput;
};

export type MutationResetAccountLockArgs = {
  data: ResetAccountLockInput;
};

export type MutationRestoreCallScheduleArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationRestorePlaylistArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationSetVoiceMessageActivationArgs = {
  deactivateDto: DeactivateVoiceMessageDto;
  id: Scalars["Int"]["input"];
  isActive: Scalars["Boolean"]["input"];
};

export type MutationUpdateAccountArgs = {
  data: UpdateAccountDto;
};

export type MutationUpdateCallPlanArgs = {
  input: UpdateCallPlanInput;
};

export type MutationUpdateCallRecordArgs = {
  callSid: Scalars["String"]["input"];
  data: Scalars["JSONObject"]["input"];
};

export type MutationUpdateCallScheduleArgs = {
  data: UpdateCallScheduleDto;
  id: Scalars["Int"]["input"];
};

export type MutationUpdateFeedbackArgs = {
  data: UpdateFeedbackDto;
};

export type MutationUpdateHealthieFormArgs = {
  callSid: Scalars["String"]["input"];
  data: Scalars["JSONObject"]["input"];
};

export type MutationUpdatePhoneNumberArgs = {
  data: UpdateUserPhoneNumberInput;
};

export type MutationUpdatePlaylistArgs = {
  data: UpdatePlaylistDto;
};

export type MutationUpdateProgramHistoryArgs = {
  data: UpdateProgramHistoryDto;
  id: Scalars["Int"]["input"];
};

export type MutationUpdateSessionCountArgs = {
  callSid: Scalars["String"]["input"];
  data: Scalars["Float"]["input"];
};

export type MutationUpdateUserArgs = {
  data: UpdateUserDto;
};

export type MutationUpdateUserNotificationPreferencesArgs = {
  input: UpdateNotificationPreferenceDto;
  userId: Scalars["Int"]["input"];
};

export type MutationUpdateVoiceMessageArgs = {
  data: UpdateVoiceMessageDto;
  id: Scalars["Int"]["input"];
};

export type MutationUploadVoiceMessageArgs = {
  durationInSeconds: Scalars["Int"]["input"];
  file: Scalars["Upload"]["input"];
  recordedById?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationUpsertDraftActivityArgs = {
  activityJSON: Scalars["JSONObject"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationVerifyOtpArgs = {
  data: VerifyMfaTokenInput;
};

export type NotificationPreference = {
  __typename?: "NotificationPreference";
  createdAt: Scalars["DateTime"]["output"];
  emailEnabled: Scalars["Boolean"]["output"];
  id: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  user: User;
  userId: Scalars["Int"]["output"];
};

export type OnboardSimpleDto = {
  Id_Ehr?: InputMaybe<Scalars["String"]["input"]>;
  activityPhoneNumber: Scalars["String"]["input"];
  contactPhoneNumber: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  isTestUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName: Scalars["String"]["input"];
  leadType?: InputMaybe<Scalars["String"]["input"]>;
  specialistId?: InputMaybe<Scalars["Int"]["input"]>;
  timeZone: Scalars["String"]["input"];
};

export type OtherInteraction = Interaction & {
  __typename?: "OtherInteraction";
  /** The ID of the activity. */
  activityId?: Maybe<Scalars["Int"]["output"]>;
  /** The text read to the user. */
  contentText?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["Int"]["output"];
  /** The sequence number of this interaction within the call plan. */
  order: Scalars["Int"]["output"];
  /** Whether user can skip to the next interaction. */
  skippable: Scalars["Boolean"]["output"];
  /** The type of interaction. */
  type: InteractionType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type PaginatedAccounts = {
  __typename?: "PaginatedAccounts";
  accounts: Array<Account>;
  total: Scalars["Int"]["output"];
};

export type PaginatedActivities = {
  __typename?: "PaginatedActivities";
  activities: Array<Activity>;
  total: Scalars["Int"]["output"];
};

export type PaginatedCallRecordResponse = {
  __typename?: "PaginatedCallRecordResponse";
  activitiesPlayed?: Maybe<Array<Array<Scalars["JSONObject"]["output"]>>>;
  count: Scalars["Int"]["output"];
  data: Array<CallRecord>;
  lastWeek: Scalars["JSONObject"]["output"];
  month: Scalars["JSONObject"]["output"];
  thisWeek: Scalars["JSONObject"]["output"];
};

export type PaginatedVoiceMessageResponse = {
  __typename?: "PaginatedVoiceMessageResponse";
  activitiesPlayed?: Maybe<Array<Array<Scalars["JSONObject"]["output"]>>>;
  count: Scalars["Int"]["output"];
  data: Array<VoiceMessage>;
  lastWeek: Scalars["JSONObject"]["output"];
  month: Scalars["JSONObject"]["output"];
  thisWeek: Scalars["JSONObject"]["output"];
};

export type Playlist = {
  __typename?: "Playlist";
  account: Account;
  createdOn: Scalars["DateTime"]["output"];
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  endOn: Scalars["DateTime"]["output"];
  id: Scalars["Int"]["output"];
  isActive: Scalars["Boolean"]["output"];
  isFreeTrial: Scalars["Boolean"]["output"];
  isInbound: Scalars["Boolean"]["output"];
  isOutbound: Scalars["Boolean"]["output"];
  isTracked: Scalars["Boolean"]["output"];
  playlistVoiceMessages: Array<PlaylistVoiceMessage>;
  program?: Maybe<ProgramHistory>;
  program_id?: Maybe<Scalars["Int"]["output"]>;
  startOn: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  updatedOn: Scalars["DateTime"]["output"];
};

export type PlaylistVoiceMessage = {
  __typename?: "PlaylistVoiceMessage";
  createdOn: Scalars["DateTime"]["output"];
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["Int"]["output"];
  order: Scalars["Int"]["output"];
  playlist: Playlist;
  updatedOn: Scalars["DateTime"]["output"];
  voiceMessage: VoiceMessage;
};

export type ProgramHistory = {
  __typename?: "ProgramHistory";
  account: Account;
  account_id: Scalars["Float"]["output"];
  callPlans: Array<CallPlan>;
  created_by: Scalars["String"]["output"];
  created_on: Scalars["DateTime"]["output"];
  end_date?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["Int"]["output"];
  program_type: Scalars["String"]["output"];
  round: Scalars["Float"]["output"];
  specialist?: Maybe<User>;
  specialistId?: Maybe<Scalars["Int"]["output"]>;
  start_date: Scalars["DateTime"]["output"];
  status?: Maybe<Scalars["String"]["output"]>;
  updated_at: Scalars["DateTime"]["output"];
  updated_by: Scalars["String"]["output"];
};

export type ProgramHistoryDto = {
  account_id: Scalars["Int"]["input"];
  end_date?: InputMaybe<Scalars["String"]["input"]>;
  program_type: ProgramType;
  specialist_id: Scalars["Int"]["input"];
  start_date: Scalars["String"]["input"];
};

export enum ProgramType {
  Intensive = "INTENSIVE",
  Maintenance = "MAINTENANCE",
}

export type Query = {
  __typename?: "Query";
  accessRecord: AccessRecord;
  accessRecords: Array<AccessRecord>;
  account: Account;
  accounts: PaginatedAccounts;
  accountsWithFilter: PaginatedAccounts;
  activities: PaginatedActivities;
  activity: Activity;
  activityLibrary: Array<VoiceMessage>;
  activityTypes: Array<ActivityType>;
  audioFile: AudioFile;
  audioFiles: Array<AudioFile>;
  callDuration: Scalars["JSONObject"]["output"];
  /** A single call plan by id. */
  callPlan: CallPlan;
  callRecord: CallRecord;
  callRecords: PaginatedCallRecordResponse;
  callSchedule: CallSchedule;
  callSchedules: Array<CallSchedule>;
  cognitiveDomains: Array<ActivityCognitiveDomain>;
  deactivatedAccount: Account;
  deactivatedAccounts: DeactivatedAccountsResponse;
  deletedCallSchedules: Array<CallSchedule>;
  difficultyEnums: Array<Scalars["String"]["output"]>;
  /** Draft activities; optional `filter` matches title (substring) or content inside `activityJSON` (full-text on JSON as text). */
  draftActivities: Array<DraftActivity>;
  feature: FeatureStatus;
  features: Array<FeatureStatus>;
  getFeedback: Feedback;
  getFeedbacks: Array<Feedback>;
  getLatestProgram: ProgramHistory;
  playlist: Playlist;
  playlistVoiceMessage: PlaylistVoiceMessage;
  playlistVoiceMessages: Array<PlaylistVoiceMessage>;
  playlists: Array<Playlist>;
  program: ProgramHistory;
  programEnums: Array<Scalars["String"]["output"]>;
  programHistory: Array<ProgramHistory>;
  programwithinDate: ProgramHistory;
  questionTypes: Array<ActivityQuestionType>;
  specialists: Array<User>;
  transcribe: GetTranscribeReturn;
  uploadProfilePhotoSignedUrl: Scalars["String"]["output"];
  user: User;
  userNotificationPreference?: Maybe<NotificationPreference>;
  users: Array<User>;
  voiceMessage: VoiceMessage;
  voiceMessages: PaginatedVoiceMessageResponse;
};

export type QueryAccessRecordArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryAccessRecordsArgs = {
  data: AccessRecordsQuery;
};

export type QueryAccountArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryAccountsArgs = {
  isTestUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  take?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAccountsWithFilterArgs = {
  ProgramType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  isTestUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  sortColumn?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<SortOrder>;
  specialistId?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  take?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryActivitiesArgs = {
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<ActivityListFiltersInput>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ActivityListSortInput>;
  take?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryActivityArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryAudioFileArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryCallDurationArgs = {
  data: CallDurationQuery;
};

export type QueryCallPlanArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryCallRecordArgs = {
  callSid: Scalars["String"]["input"];
};

export type QueryCallRecordsArgs = {
  data: CallRecordsQuery;
};

export type QueryCallScheduleArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryDeactivatedAccountArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryDeactivatedAccountsArgs = {
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  take?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryDeletedCallSchedulesArgs = {
  accountId: Scalars["Int"]["input"];
};

export type QueryDraftActivitiesArgs = {
  filter?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryFeatureArgs = {
  featureName: Scalars["String"]["input"];
};

export type QueryGetFeedbackArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGetFeedbacksArgs = {
  createdBy?: InputMaybe<Scalars["String"]["input"]>;
  rating?: InputMaybe<Scalars["Float"]["input"]>;
};

export type QueryGetLatestProgramArgs = {
  account_id: Scalars["Int"]["input"];
};

export type QueryPlaylistArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryPlaylistVoiceMessageArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryProgramArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryProgramHistoryArgs = {
  account_id: Scalars["Int"]["input"];
};

export type QueryProgramwithinDateArgs = {
  account_id: Scalars["Int"]["input"];
  endDate: Scalars["String"]["input"];
  startDate: Scalars["String"]["input"];
};

export type QueryTranscribeArgs = {
  callSid: Scalars["String"]["input"];
};

export type QueryUploadProfilePhotoSignedUrlArgs = {
  accountId: Scalars["Int"]["input"];
};

export type QueryUserArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryUserNotificationPreferenceArgs = {
  userId: Scalars["Int"]["input"];
};

export type QueryVoiceMessageArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryVoiceMessagesArgs = {
  data: VoiceMessageQuery;
};

/** Question step: content row plus ActivityQuestion fields and flattened question type columns. */
export type QuestionActivityContent = ActivityContent & {
  __typename?: "QuestionActivityContent";
  createdAt: Scalars["DateTime"]["output"];
  /** Expected answers for the question. */
  expectedAnswers?: Maybe<Array<ExpectedAnswer>>;
  id: Scalars["Int"]["output"];
  /** Whether the question is scorable. */
  isScorable: Scalars["Boolean"]["output"];
  /** The number of expected answers for this question. */
  numRequiredParts: Scalars["Int"]["output"];
  /** Detailed description of the question type. */
  questionTypeDescription: Scalars["String"]["output"];
  /** Unique key for the question type. */
  questionTypeKey: Scalars["String"]["output"];
  /** Human readable label of the question type. */
  questionTypeLabel: Scalars["String"]["output"];
  /** Text read to the user. */
  readableText: Scalars["String"]["output"];
  /** The maximum amount of time in seconds the user has to answer the question. */
  responseTimeLimitSec?: Maybe<Scalars["Int"]["output"]>;
  /** Optional specific scoring instructions for this question, that are not already included in the question type. */
  scoringInstructions?: Maybe<Scalars["String"]["output"]>;
  /** Playback order within the activity. */
  sequenceOrder: Scalars["Int"]["output"];
  /** The amount of time in seconds the user can be silent before the system moves to the next step. */
  silenceBeforeResponseSec?: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type RefreshTokenInput = {
  refreshToken: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
};

export type ResetAccountLockInput = {
  userId: Scalars["String"]["input"];
};

export type ResetAccountLockSession = {
  __typename?: "ResetAccountLockSession";
  done: Scalars["Boolean"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
};

export enum SortOrder {
  Asc = "ASC",
  Desc = "DESC",
}

export enum SortingDirection {
  Ascending = "Ascending",
  Descending = "Descending",
}

export enum StatusView {
  Active = "Active",
  All = "All",
  Deleted = "Deleted",
}

export type UpdateAccountDto = {
  Id_Ehr?: InputMaybe<Scalars["String"]["input"]>;
  activityPhoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  bdlProgramEndOn?: InputMaybe<Scalars["String"]["input"]>;
  bdlProgramStartOn?: InputMaybe<Scalars["String"]["input"]>;
  contactPhoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  lastScamWarning?: InputMaybe<Scalars["String"]["input"]>;
  leadType?: InputMaybe<Scalars["String"]["input"]>;
  programEndOn?: InputMaybe<Scalars["String"]["input"]>;
  programStartOn?: InputMaybe<Scalars["String"]["input"]>;
  specialistId?: InputMaybe<Scalars["Int"]["input"]>;
  summary?: InputMaybe<Scalars["String"]["input"]>;
  timeZone?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateCallPlanInput = {
  /** The activities to include in this call plan, in order. */
  activityIds: Array<Scalars["Int"]["input"]>;
  callPlanId: Scalars["Int"]["input"];
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  startDate: Scalars["String"]["input"];
};

export type UpdateCallScheduleDto = {
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
  callFlowVersion?: InputMaybe<CallFlowVersion>;
  cronExpression?: InputMaybe<Scalars["String"]["input"]>;
  timeZone?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateNotificationPreferenceDto = {
  emailEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdatePlaylistDto = {
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
  endOn?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  isFreeTrial?: InputMaybe<Scalars["Boolean"]["input"]>;
  isInbound?: InputMaybe<Scalars["Boolean"]["input"]>;
  isOutbound?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTracked?: InputMaybe<Scalars["Boolean"]["input"]>;
  programId?: InputMaybe<Scalars["Int"]["input"]>;
  startOn?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  voiceMessageIds?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type UpdateProgramHistoryDto = {
  end_date?: InputMaybe<Scalars["String"]["input"]>;
  specialist_id: Scalars["Int"]["input"];
  start_date: Scalars["String"]["input"];
};

export type UpdateUserDto = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  isSpecialist?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTestUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateUserPhoneNumberInput = {
  phoneNumber: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type UpdateUserPhoneNumberSession = {
  __typename?: "UpdateUserPhoneNumberSession";
  done: Scalars["Boolean"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
};

export type UpdateVoiceMessageDto = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  cognitiveDomains?: InputMaybe<Array<Scalars["String"]["input"]>>;
  cognitiveLevel?: InputMaybe<Scalars["String"]["input"]>;
  deactivationNote?: InputMaybe<Scalars["String"]["input"]>;
  difficulty?: InputMaybe<DifficultyType>;
  durationInSeconds?: InputMaybe<Scalars["Int"]["input"]>;
  endOn?: InputMaybe<Scalars["String"]["input"]>;
  feature?: InputMaybe<Scalars["String"]["input"]>;
  focus?: InputMaybe<Scalars["String"]["input"]>;
  inLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  recordedById?: InputMaybe<Scalars["Int"]["input"]>;
  recordedForId?: InputMaybe<Scalars["Int"]["input"]>;
  startOn?: InputMaybe<Scalars["String"]["input"]>;
  templateLink?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type User = {
  __typename?: "User";
  account?: Maybe<Account>;
  assignees?: Maybe<Array<Account>>;
  createdOn: Scalars["DateTime"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  firstName: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  isSpecialist: Scalars["Boolean"]["output"];
  isTestUser: Scalars["Boolean"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  updatedOn: Scalars["DateTime"]["output"];
};

export type VerifyMfaSession = {
  __typename?: "VerifyMFASession";
  done: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
};

export type VerifyMfaTokenInput = {
  code: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type VoiceMessage = {
  __typename?: "VoiceMessage";
  approvedOn?: Maybe<Scalars["DateTime"]["output"]>;
  audioFile: AudioFile;
  category?: Maybe<Scalars["String"]["output"]>;
  cognitiveDomains?: Maybe<Array<Scalars["String"]["output"]>>;
  cognitiveLevel?: Maybe<Scalars["String"]["output"]>;
  createdOn: Scalars["DateTime"]["output"];
  deactivationNote?: Maybe<Scalars["String"]["output"]>;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  difficulty?: Maybe<Scalars["String"]["output"]>;
  endOn?: Maybe<Scalars["DateTime"]["output"]>;
  feature?: Maybe<Scalars["String"]["output"]>;
  focus?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
  inLibrary: Scalars["Boolean"]["output"];
  recordedBy?: Maybe<User>;
  recordedFor?: Maybe<Account>;
  recordedTitle?: Maybe<AudioFile>;
  startOn?: Maybe<Scalars["DateTime"]["output"]>;
  templateLink?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedOn: Scalars["DateTime"]["output"];
};

export type VoiceMessageQuery = {
  cognitiveDomain?: InputMaybe<CognitiveDomain>;
  cognitiveLevel?: InputMaybe<CognitiveLevel>;
  difficulty?: InputMaybe<Difficulty>;
  feature?: InputMaybe<Feature>;
  inLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  statusView?: InputMaybe<StatusView>;
  take?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ChangePasswordInput = {
  PreviousPassword: Scalars["String"]["input"];
  ProposedPassword: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
};

export type CreateFeedbackDto = {
  callSid: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  rating: Scalars["Float"]["input"];
  reason?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type UpdateFeedbackDto = {
  callSid: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  rating: Scalars["Float"]["input"];
  reason?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type AllFeaturesQueryVariables = Exact<{ [key: string]: never }>;

export type AllFeaturesQuery = {
  __typename?: "Query";
  features: Array<{
    __typename?: "FeatureStatus";
    featureName: string;
    enabled: boolean;
    treatment: string;
  }>;
};

export type AccountBasicInfoFragment = {
  __typename?: "Account";
  id: number;
  firstName: string;
  lastName?: string | null;
  deletedAt?: string | null;
  timeZone?: string | null;
  summary?: string | null;
  leadType?: string | null;
  Id_Ehr?: string | null;
  contactPhoneNumber?: string | null;
  activityPhoneNumber?: string | null;
  bdlProgramStartOn?: string | null;
  bdlProgramEndOn?: string | null;
  latest_program_type?: string | null;
  latest_program_type_status?: string | null;
  programStartOn?: string | null;
  programEndOn?: string | null;
};

export type UserInfoFragment = {
  __typename?: "User";
  id: number;
  firstName: string;
  lastName?: string | null;
  email?: string | null;
  isTestUser: boolean;
};

export type SpecialistInfoFragment = {
  __typename?: "User";
  id: number;
  firstName: string;
  lastName?: string | null;
  email?: string | null;
};

export type PlaylistBasicInfoFragment = {
  __typename?: "Playlist";
  id: number;
  title: string;
  startOn: string;
  endOn: string;
  isActive: boolean;
};

export type PlaylistWithProgramFragment = {
  __typename?: "Playlist";
  id: number;
  title: string;
  startOn: string;
  endOn: string;
  isActive: boolean;
  program?: { __typename?: "ProgramHistory"; id: number } | null;
};

export type VoiceMessageInfoFragment = {
  __typename?: "VoiceMessage";
  title?: string | null;
  templateLink?: string | null;
  feature?: string | null;
  cognitiveDomains?: Array<string> | null;
};

export type VoiceMessageDetailedFragment = {
  __typename?: "VoiceMessage";
  id: number;
  title?: string | null;
  feature?: string | null;
  templateLink?: string | null;
  focus?: string | null;
  cognitiveDomains?: Array<string> | null;
  audioFile: { __typename?: "AudioFile"; id: number; durationInSeconds?: number | null };
};

export type PlaylistVoiceMessageFragment = {
  __typename?: "PlaylistVoiceMessage";
  voiceMessage: {
    __typename?: "VoiceMessage";
    title?: string | null;
    templateLink?: string | null;
    feature?: string | null;
    cognitiveDomains?: Array<string> | null;
  };
};

export type PlaylistVoiceMessageDetailedFragment = {
  __typename?: "PlaylistVoiceMessage";
  id: number;
  order: number;
  createdOn: string;
  updatedOn: string;
  playlist: { __typename?: "Playlist"; id: number; title: string };
  voiceMessage: {
    __typename?: "VoiceMessage";
    id: number;
    title?: string | null;
    feature?: string | null;
    templateLink?: string | null;
    focus?: string | null;
    cognitiveDomains?: Array<string> | null;
    audioFile: { __typename?: "AudioFile"; id: number; durationInSeconds?: number | null };
  };
};

export type PlaylistDetailedFragment = {
  __typename?: "Playlist";
  id: number;
  title: string;
  isActive: boolean;
  startOn: string;
  endOn: string;
  createdOn: string;
  updatedOn: string;
  deletedAt?: string | null;
  program?: {
    __typename?: "ProgramHistory";
    id: number;
    round: number;
    program_type: string;
    start_date: string;
    end_date?: string | null;
  } | null;
  playlistVoiceMessages: Array<{
    __typename?: "PlaylistVoiceMessage";
    id: number;
    order: number;
    createdOn: string;
    updatedOn: string;
    playlist: { __typename?: "Playlist"; id: number; title: string };
    voiceMessage: {
      __typename?: "VoiceMessage";
      id: number;
      title?: string | null;
      feature?: string | null;
      templateLink?: string | null;
      focus?: string | null;
      cognitiveDomains?: Array<string> | null;
      audioFile: { __typename?: "AudioFile"; id: number; durationInSeconds?: number | null };
    };
  }>;
};

export type CallRecordBasicFragment = {
  __typename?: "CallRecord";
  sid: string;
  durationInSeconds?: number | null;
  outcome: CallOutcome;
  type: CallType;
  createdOn: string;
  recordingDownloadUrl?: string | null;
  programRating?: number | null;
  fullProgramRatingResponse?: string | null;
  reflectionOnLearnings?: string | null;
  errorDetails?: string | null;
  hangupDetails?: string | null;
  hbacalldata?: Array<string> | null;
  sessionCount?: number | null;
};

export type CallRecordWithPlaylistFragment = {
  __typename?: "CallRecord";
  sid: string;
  durationInSeconds?: number | null;
  outcome: CallOutcome;
  type: CallType;
  createdOn: string;
  recordingDownloadUrl?: string | null;
  programRating?: number | null;
  fullProgramRatingResponse?: string | null;
  reflectionOnLearnings?: string | null;
  errorDetails?: string | null;
  hangupDetails?: string | null;
  hbacalldata?: Array<string> | null;
  sessionCount?: number | null;
  playlist?: {
    __typename?: "Playlist";
    id: number;
    title: string;
    startOn: string;
    endOn: string;
    isActive: boolean;
  } | null;
};

export type AccountFullInfoFragment = {
  __typename?: "Account";
  id: number;
  firstName: string;
  lastName?: string | null;
  deletedAt?: string | null;
  timeZone?: string | null;
  summary?: string | null;
  leadType?: string | null;
  Id_Ehr?: string | null;
  contactPhoneNumber?: string | null;
  activityPhoneNumber?: string | null;
  bdlProgramStartOn?: string | null;
  bdlProgramEndOn?: string | null;
  latest_program_type?: string | null;
  latest_program_type_status?: string | null;
  programStartOn?: string | null;
  programEndOn?: string | null;
  specialist?: {
    __typename?: "User";
    id: number;
    firstName: string;
    lastName?: string | null;
    email?: string | null;
  } | null;
  user?: {
    __typename?: "User";
    id: number;
    firstName: string;
    lastName?: string | null;
    email?: string | null;
    isTestUser: boolean;
  } | null;
  playlists?: Array<{
    __typename?: "Playlist";
    id: number;
    title: string;
    startOn: string;
    endOn: string;
    isActive: boolean;
    program?: { __typename?: "ProgramHistory"; id: number } | null;
  }> | null;
  latestProgram?: {
    __typename?: "ProgramHistory";
    id: number;
    program_type: string;
    start_date: string;
    end_date?: string | null;
  } | null;
};

export type ProgramHistoryInfoFragment = {
  __typename?: "ProgramHistory";
  id: number;
  program_type: string;
  start_date: string;
  end_date?: string | null;
  round: number;
  created_on: string;
  updated_at: string;
  status?: string | null;
};

export type ProgramHistoryWithSpecialistFragment = {
  __typename?: "ProgramHistory";
  id: number;
  program_type: string;
  start_date: string;
  end_date?: string | null;
  round: number;
  created_on: string;
  updated_at: string;
  status?: string | null;
  specialist?: {
    __typename?: "User";
    id: number;
    firstName: string;
    lastName?: string | null;
    email?: string | null;
  } | null;
};

export type CallPlanInfoFragment = {
  __typename?: "CallPlan";
  id: number;
  programWeek: number;
  startDate: string;
  endDate?: string | null;
  isActive: boolean;
  program: {
    __typename?: "ProgramHistory";
    id: number;
    round: number;
    program_type: string;
    start_date: string;
    end_date?: string | null;
    status?: string | null;
  };
  interactions?: Array<
    | { __typename?: "ActivityInteraction"; id: number }
    | { __typename?: "OtherInteraction"; id: number }
  > | null;
};

export type CallScheduleInfoFragment = {
  __typename?: "CallSchedule";
  id: number;
  cronExpression: string;
  scheduleDescription: string;
  callFlowVersion: CallFlowVersion;
  createdOn: string;
};

export type GetSingleUserAccountFragment = {
  __typename?: "Account";
  id: number;
  firstName: string;
  lastName?: string | null;
  contactPhoneNumber?: string | null;
  activityPhoneNumber?: string | null;
  timeZone?: string | null;
  summary?: string | null;
  programStartOn?: string | null;
  programEndOn?: string | null;
  bdlProgramStartOn?: string | null;
  bdlProgramEndOn?: string | null;
  createdOn: string;
  deletedAt?: string | null;
  profilePhotoUrl?: string | null;
  leadType?: string | null;
  Id_Ehr?: string | null;
  latest_program_type?: string | null;
  user?: {
    __typename?: "User";
    id: number;
    firstName: string;
    lastName?: string | null;
    email?: string | null;
    isTestUser: boolean;
  } | null;
  specialist?: { __typename?: "User"; id: number; firstName: string } | null;
  playlists?: Array<{
    __typename?: "Playlist";
    id: number;
    title: string;
    isActive: boolean;
    startOn: string;
    endOn: string;
    createdOn: string;
    updatedOn: string;
    deletedAt?: string | null;
    program?: {
      __typename?: "ProgramHistory";
      id: number;
      round: number;
      program_type: string;
      start_date: string;
      end_date?: string | null;
    } | null;
    playlistVoiceMessages: Array<{
      __typename?: "PlaylistVoiceMessage";
      id: number;
      order: number;
      createdOn: string;
      updatedOn: string;
      playlist: { __typename?: "Playlist"; id: number; title: string };
      voiceMessage: {
        __typename?: "VoiceMessage";
        id: number;
        title?: string | null;
        feature?: string | null;
        templateLink?: string | null;
        focus?: string | null;
        cognitiveDomains?: Array<string> | null;
        audioFile: { __typename?: "AudioFile"; id: number; durationInSeconds?: number | null };
      };
    }>;
  }> | null;
  callPlans: Array<{
    __typename?: "CallPlan";
    id: number;
    programWeek: number;
    startDate: string;
    endDate?: string | null;
    isActive: boolean;
    program: {
      __typename?: "ProgramHistory";
      id: number;
      round: number;
      program_type: string;
      start_date: string;
      end_date?: string | null;
      status?: string | null;
    };
    interactions?: Array<
      | { __typename?: "ActivityInteraction"; id: number }
      | { __typename?: "OtherInteraction"; id: number }
    > | null;
  }>;
  callRecords?: Array<{
    __typename?: "CallRecord";
    sid: string;
    activities?: Array<{
      __typename?: "ActivityRecord";
      id: number;
      callSid: string;
      voiceMessage: { __typename?: "VoiceMessage"; id: number };
    }> | null;
  }> | null;
  callSchedules?: Array<{
    __typename?: "CallSchedule";
    id: number;
    cronExpression: string;
    scheduleDescription: string;
    callFlowVersion: CallFlowVersion;
    createdOn: string;
  }> | null;
};

export type ExpireRefreshTokenMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type ExpireRefreshTokenMutation = {
  __typename?: "Mutation";
  expireRefreshToken: { __typename?: "ExpireRefreshTokenResponse"; done: boolean };
};

export type QuerySpecialistsDropdownQueryVariables = Exact<{ [key: string]: never }>;

export type QuerySpecialistsDropdownQuery = {
  __typename?: "Query";
  specialists: Array<{
    __typename?: "User";
    id: number;
    firstName: string;
    lastName?: string | null;
    email?: string | null;
  }>;
};

export type GetAccessNotificationsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetAccessNotificationsQuery = {
  __typename?: "Query";
  accessRecords: Array<{
    __typename?: "AccessRecord";
    id: number;
    accessedBy: string;
    source: string;
    createdOn: string;
    updatedOn: string;
    account?: {
      __typename?: "Account";
      id: number;
      firstName: string;
      lastName?: string | null;
    } | null;
  }>;
};

export type GetSingleActivityQueryVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type GetSingleActivityQuery = {
  __typename?: "Query";
  voiceMessage: {
    __typename?: "VoiceMessage";
    id: number;
    title?: string | null;
    templateLink?: string | null;
    feature?: string | null;
    focus?: string | null;
    difficulty?: string | null;
    cognitiveDomains?: Array<string> | null;
    inLibrary: boolean;
    createdOn: string;
    deletedAt?: string | null;
    deactivationNote?: string | null;
    recordedBy?: { __typename?: "User"; id: number } | null;
    audioFile: {
      __typename?: "AudioFile";
      id: number;
      durationInSeconds?: number | null;
      filename: string;
      downloadUrl?: string | null;
    };
  };
};

export type UpdateVoiceMessageMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  title: Scalars["String"]["input"];
  templateLink?: InputMaybe<Scalars["String"]["input"]>;
  feature?: InputMaybe<Scalars["String"]["input"]>;
  focus?: InputMaybe<Scalars["String"]["input"]>;
  inLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  recordedById: Scalars["Int"]["input"];
  cognitiveDomains?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
  difficulty?: InputMaybe<DifficultyType>;
}>;

export type UpdateVoiceMessageMutation = {
  __typename?: "Mutation";
  updateVoiceMessage: {
    __typename?: "VoiceMessage";
    id: number;
    title?: string | null;
    templateLink?: string | null;
    feature?: string | null;
    focus?: string | null;
    cognitiveDomains?: Array<string> | null;
    difficulty?: string | null;
    createdOn: string;
    recordedBy?: { __typename?: "User"; id: number } | null;
    audioFile: {
      __typename?: "AudioFile";
      id: number;
      durationInSeconds?: number | null;
      filename: string;
    };
  };
};

export type SetVoiceMessageActivationMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  isActive: Scalars["Boolean"]["input"];
  deactivationNote?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SetVoiceMessageActivationMutation = {
  __typename?: "Mutation";
  setVoiceMessageActivation: {
    __typename?: "VoiceMessage";
    id: number;
    deletedAt?: string | null;
    createdOn: string;
    recordedBy?: { __typename?: "User"; id: number } | null;
    audioFile: { __typename?: "AudioFile"; durationInSeconds?: number | null; filename: string };
  };
};

export type GetAllActivitiesQueryVariables = Exact<{
  take?: InputMaybe<Scalars["Int"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  inLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  statusView?: InputMaybe<StatusView>;
  cognitiveDomain?: InputMaybe<CognitiveDomain>;
  feature?: InputMaybe<Feature>;
}>;

export type GetAllActivitiesQuery = {
  __typename?: "Query";
  voiceMessages: {
    __typename?: "PaginatedVoiceMessageResponse";
    count: number;
    data: Array<{
      __typename?: "VoiceMessage";
      id: number;
      title?: string | null;
      templateLink?: string | null;
      category?: string | null;
      feature?: string | null;
      focus?: string | null;
      cognitiveDomains?: Array<string> | null;
      deletedAt?: string | null;
      createdOn: string;
      difficulty?: string | null;
      recordedBy?: { __typename?: "User"; id: number } | null;
      audioFile: {
        __typename?: "AudioFile";
        id: number;
        durationInSeconds?: number | null;
        filename: string;
        downloadUrl?: string | null;
      };
    }>;
  };
};

export type UploadVoiceMessageMutationVariables = Exact<{
  file: Scalars["Upload"]["input"];
  durationInSeconds: Scalars["Int"]["input"];
}>;

export type UploadVoiceMessageMutation = {
  __typename?: "Mutation";
  uploadVoiceMessage: { __typename?: "VoiceMessage"; id: number };
};

export type GetDifficultyEnumsQueryVariables = Exact<{ [key: string]: never }>;

export type GetDifficultyEnumsQuery = { __typename?: "Query"; difficultyEnums: Array<string> };

export type GetQuestionTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetQuestionTypesQuery = {
  __typename?: "Query";
  questionTypes: Array<{
    __typename?: "ActivityQuestionType";
    id: number;
    questionTypeDescription: string;
    questionTypeKey: string;
    questionTypeLabel: string;
  }>;
};

export type GetDraftActivitiesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetDraftActivitiesQuery = {
  __typename?: "Query";
  draftActivities: Array<{
    __typename?: "DraftActivity";
    id: number;
    title: string;
    activityJSON: any;
    updatedAt: string;
  }>;
};

export type UpsertDraftActivityMutationVariables = Exact<{
  activityJSON: Scalars["JSONObject"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type UpsertDraftActivityMutation = {
  __typename?: "Mutation";
  upsertDraftActivity: {
    __typename?: "DraftActivity";
    id: number;
    title: string;
    activityJSON: any;
    createdAt: string;
    updatedAt: string;
  };
};

export type CreateFeedbackMutationVariables = Exact<{
  data: CreateFeedbackDto;
}>;

export type CreateFeedbackMutation = {
  __typename?: "Mutation";
  createFeedback: {
    __typename?: "Feedback";
    id: number;
    callSid: string;
    rating: number;
    reason?: Array<string> | null;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
  };
};

export type GetFeedbackQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetFeedbackQuery = {
  __typename?: "Query";
  getFeedback: {
    __typename?: "Feedback";
    id: number;
    callSid: string;
    rating: number;
    reason?: Array<string> | null;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
  };
};

export type GetFeedbacksQueryVariables = Exact<{
  createdBy?: InputMaybe<Scalars["String"]["input"]>;
  rating?: InputMaybe<Scalars["Float"]["input"]>;
}>;

export type GetFeedbacksQuery = {
  __typename?: "Query";
  getFeedbacks: Array<{
    __typename?: "Feedback";
    id: number;
    callSid: string;
    rating: number;
    reason?: Array<string> | null;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
  }>;
};

export type UpdateFeedbackMutationVariables = Exact<{
  data: UpdateFeedbackDto;
}>;

export type UpdateFeedbackMutation = {
  __typename?: "Mutation";
  updateFeedback: {
    __typename?: "Feedback";
    id: number;
    callSid: string;
    rating: number;
    reason?: Array<string> | null;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
  };
};

export type ChangePasswordMutationVariables = Exact<{
  username: Scalars["String"]["input"];
  PreviousPassword: Scalars["String"]["input"];
  ProposedPassword: Scalars["String"]["input"];
}>;

export type ChangePasswordMutation = {
  __typename?: "Mutation";
  changePassword: { __typename?: "ChangePass"; done: boolean };
};

export type GetUserNotificationPreferenceQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
}>;

export type GetUserNotificationPreferenceQuery = {
  __typename?: "Query";
  userNotificationPreference?: {
    __typename?: "NotificationPreference";
    userId: number;
    emailEnabled: boolean;
  } | null;
};

export type UpdateUserNotificationPreferencesMutationVariables = Exact<{
  userId: Scalars["Int"]["input"];
  input: UpdateNotificationPreferenceDto;
}>;

export type UpdateUserNotificationPreferencesMutation = {
  __typename?: "Mutation";
  updateUserNotificationPreferences: {
    __typename?: "NotificationPreference";
    id: number;
    emailEnabled: boolean;
  };
};

export type GetSingleDeactivatedUserQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
}>;

export type GetSingleDeactivatedUserQuery = {
  __typename?: "Query";
  deactivatedAccount: {
    __typename?: "Account";
    id: number;
    firstName: string;
    lastName?: string | null;
    contactPhoneNumber?: string | null;
    activityPhoneNumber?: string | null;
    timeZone?: string | null;
    summary?: string | null;
    programStartOn?: string | null;
    programEndOn?: string | null;
    createdOn: string;
    deletedAt?: string | null;
  };
};

export type GetLoginMutationVariables = Exact<{
  username: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
}>;

export type GetLoginMutation = {
  __typename?: "Mutation";
  login: {
    __typename?: "AuthSession";
    accessToken: string;
    refreshToken: string;
    idToken: string;
    isValid: boolean;
    lastPass?: string | null;
  };
};

export type GetOtpMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
  method: Scalars["String"]["input"];
}>;

export type GetOtpMutation = {
  __typename?: "Mutation";
  getOtp: { __typename?: "MFASession"; done: boolean; message: string };
};

export type VerifyOtpMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
  code: Scalars["String"]["input"];
}>;

export type VerifyOtpMutation = {
  __typename?: "Mutation";
  verifyOtp: { __typename?: "VerifyMFASession"; done: boolean; message: string };
};

export type UpdatePhoneNumberMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
}>;

export type UpdatePhoneNumberMutation = {
  __typename?: "Mutation";
  updatePhoneNumber: { __typename?: "UpdateUserPhoneNumberSession"; done: boolean };
};

export type GetActivitiesQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  take?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<ActivityListFiltersInput>;
  sort?: InputMaybe<ActivityListSortInput>;
}>;

export type GetActivitiesQuery = {
  __typename?: "Query";
  activities: {
    __typename?: "PaginatedActivities";
    total: number;
    activities: Array<{
      __typename?: "Activity";
      id: number;
      title: string;
      category: ActivityCategory;
      difficulty: ActivityDifficulty;
      lastDeliveryTime?: string | null;
      earliestFutureCallPlan?: {
        __typename?: "CallPlan";
        id: number;
        programWeek: number;
        startDate: string;
        endDate?: string | null;
      } | null;
      activityTypes: Array<{
        __typename?: "ActivityType";
        activityTypeKey: string;
        activityTypeLabel: string;
      }>;
    }>;
  };
};

export type GetActivityTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetActivityTypesQuery = {
  __typename?: "Query";
  activityTypes: Array<{
    __typename?: "ActivityType";
    activityTypeKey: string;
    activityTypeLabel: string;
    displayOrder: number;
  }>;
};

export type GetActivityQueryVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type GetActivityQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "Activity";
    id: number;
    title: string;
    description: string;
    contents: Array<
      | {
          __typename?: "InstructionActivityContent";
          id: number;
          sequenceOrder: number;
          readableText: string;
        }
      | {
          __typename?: "QuestionActivityContent";
          questionTypeLabel: string;
          id: number;
          sequenceOrder: number;
          readableText: string;
          expectedAnswers?: Array<{
            __typename?: "ExpectedAnswer";
            id: number;
            expectedAnswerText: string;
          }> | null;
        }
    >;
    createdBy: { __typename?: "User"; id: number; firstName: string; lastName?: string | null };
  };
};

export type CreateCallPlanMutationVariables = Exact<{
  input: CreateCallPlanInput;
}>;

export type CreateCallPlanMutation = {
  __typename?: "Mutation";
  createCallPlan: {
    __typename?: "CallPlan";
    id: number;
    programWeek: number;
    startDate: string;
    endDate?: string | null;
    isActive: boolean;
    program: {
      __typename?: "ProgramHistory";
      id: number;
      round: number;
      program_type: string;
      start_date: string;
      end_date?: string | null;
      status?: string | null;
    };
    interactions?: Array<
      | { __typename?: "ActivityInteraction"; id: number }
      | { __typename?: "OtherInteraction"; id: number }
    > | null;
  };
};

export type UpdateCallPlanMutationVariables = Exact<{
  input: UpdateCallPlanInput;
}>;

export type UpdateCallPlanMutation = {
  __typename?: "Mutation";
  updateCallPlan: {
    __typename?: "CallPlan";
    id: number;
    programWeek: number;
    startDate: string;
    endDate?: string | null;
    isActive: boolean;
    program: {
      __typename?: "ProgramHistory";
      id: number;
      round: number;
      program_type: string;
      start_date: string;
      end_date?: string | null;
      status?: string | null;
    };
    interactions?: Array<
      | { __typename?: "ActivityInteraction"; id: number }
      | { __typename?: "OtherInteraction"; id: number }
    > | null;
  };
};

export type DeleteCallPlanMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type DeleteCallPlanMutation = { __typename?: "Mutation"; deleteCallPlan: boolean };

export type GetCallPlanActivitiesQueryVariables = Exact<{
  callPlanId: Scalars["Int"]["input"];
}>;

export type GetCallPlanActivitiesQuery = {
  __typename?: "Query";
  callPlan: {
    __typename?: "CallPlan";
    id: number;
    interactions?: Array<
      | {
          __typename?: "ActivityInteraction";
          activityId?: number | null;
          title: string;
          category: ActivityCategory;
          difficulty: ActivityDifficulty;
          id: number;
          order: number;
          activityTypes: Array<{
            __typename?: "ActivityType";
            activityTypeKey: string;
            activityTypeLabel: string;
          }>;
        }
      | { __typename?: "OtherInteraction"; id: number; order: number }
    > | null;
  };
};

export type GetCallPlanDetailQueryVariables = Exact<{
  callPlanId: Scalars["Int"]["input"];
}>;

export type GetCallPlanDetailQuery = {
  __typename?: "Query";
  callPlan: {
    __typename?: "CallPlan";
    id: number;
    programWeek: number;
    startDate: string;
    endDate?: string | null;
    isActive: boolean;
    program: {
      __typename?: "ProgramHistory";
      id: number;
      round: number;
      program_type: string;
      start_date: string;
      end_date?: string | null;
    };
    interactions?: Array<
      | {
          __typename?: "ActivityInteraction";
          activityId?: number | null;
          title: string;
          description: string;
          estimatedDuration?: number | null;
          id: number;
          order: number;
          skippable: boolean;
          contents: Array<
            | {
                __typename?: "InstructionActivityContent";
                id: number;
                sequenceOrder: number;
                readableText: string;
              }
            | {
                __typename?: "QuestionActivityContent";
                questionTypeLabel: string;
                responseTimeLimitSec?: number | null;
                silenceBeforeResponseSec?: number | null;
                id: number;
                sequenceOrder: number;
                readableText: string;
                expectedAnswers?: Array<{
                  __typename?: "ExpectedAnswer";
                  id: number;
                  expectedAnswerText: string;
                }> | null;
              }
          >;
          voiceMessage?: {
            __typename?: "VoiceMessage";
            id: number;
            audioFile: { __typename?: "AudioFile"; durationInSeconds?: number | null };
            recordedBy?: {
              __typename?: "User";
              id: number;
              firstName: string;
              lastName?: string | null;
            } | null;
          } | null;
        }
      | {
          __typename?: "OtherInteraction";
          type: InteractionType;
          contentText?: string | null;
          id: number;
          order: number;
          skippable: boolean;
        }
    > | null;
  };
};

export type CreatePlaylistMutationVariables = Exact<{
  accountId: Scalars["Int"]["input"];
  title: Scalars["String"]["input"];
  voiceMessageIds: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"];
  startOn: Scalars["String"]["input"];
  endOn: Scalars["String"]["input"];
  isFreeTrial: Scalars["Boolean"]["input"];
  isTracked: Scalars["Boolean"]["input"];
}>;

export type CreatePlaylistMutation = {
  __typename?: "Mutation";
  createPlaylist: {
    __typename?: "Playlist";
    id: number;
    title: string;
    startOn: string;
    endOn: string;
    createdOn: string;
    updatedOn: string;
    program?: {
      __typename?: "ProgramHistory";
      id: number;
      round: number;
      program_type: string;
    } | null;
  };
};

export type GetSinglePlaylistQueryVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type GetSinglePlaylistQuery = {
  __typename?: "Query";
  playlist: {
    __typename?: "Playlist";
    id: number;
    title: string;
    isActive: boolean;
    startOn: string;
    endOn: string;
    createdOn: string;
    updatedOn: string;
    deletedAt?: string | null;
    isFreeTrial: boolean;
    isTracked: boolean;
    account: {
      __typename?: "Account";
      id: number;
      firstName: string;
      lastName?: string | null;
      timeZone?: string | null;
    };
    program?: {
      __typename?: "ProgramHistory";
      id: number;
      program_type: string;
      round: number;
    } | null;
    playlistVoiceMessages: Array<{
      __typename?: "PlaylistVoiceMessage";
      id: number;
      order: number;
      voiceMessage: {
        __typename?: "VoiceMessage";
        id: number;
        title?: string | null;
        feature?: string | null;
        focus?: string | null;
        templateLink?: string | null;
        cognitiveDomains?: Array<string> | null;
        createdOn: string;
        audioFile: { __typename?: "AudioFile"; id: number; durationInSeconds?: number | null };
      };
    }>;
  };
};

export type UpdateSinglePlaylistMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
  voiceMessageIds?: InputMaybe<Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]>;
  startOn?: InputMaybe<Scalars["String"]["input"]>;
  endOn?: InputMaybe<Scalars["String"]["input"]>;
  isFreeTrial?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTracked?: InputMaybe<Scalars["Boolean"]["input"]>;
  programId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type UpdateSinglePlaylistMutation = {
  __typename?: "Mutation";
  updatePlaylist: {
    __typename?: "Playlist";
    id: number;
    title: string;
    startOn: string;
    endOn: string;
    createdOn: string;
    updatedOn: string;
  };
};

export type DeleteSinglePlaylistMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type DeleteSinglePlaylistMutation = {
  __typename?: "Mutation";
  deletePlaylist: {
    __typename?: "Playlist";
    id: number;
    title: string;
    startOn: string;
    endOn: string;
    createdOn: string;
    updatedOn: string;
  };
};

export type GetTreatmentHistoryQueryVariables = Exact<{
  accountId: Scalars["Int"]["input"];
}>;

export type GetTreatmentHistoryQuery = {
  __typename?: "Query";
  treatmentHistory: Array<{
    __typename?: "ProgramHistory";
    id: number;
    program_type: string;
    start_date: string;
    end_date?: string | null;
    round: number;
    created_on: string;
    updated_at: string;
    status?: string | null;
    specialist?: {
      __typename?: "User";
      id: number;
      firstName: string;
      lastName?: string | null;
      email?: string | null;
    } | null;
  }>;
};

export type GetCallRecordsQueryVariables = Exact<{
  take?: InputMaybe<Scalars["Int"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  sortDirection?: InputMaybe<SortingDirection>;
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
  minDuration?: InputMaybe<Scalars["Int"]["input"]>;
  playlistId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetCallRecordsQuery = {
  __typename?: "Query";
  callRecords: {
    __typename?: "PaginatedCallRecordResponse";
    count: number;
    thisWeek: any;
    lastWeek: any;
    activitiesPlayed?: Array<Array<any>> | null;
    month: any;
    data: Array<{
      __typename?: "CallRecord";
      sid: string;
      durationInSeconds?: number | null;
      outcome: CallOutcome;
      type: CallType;
      createdOn: string;
      recordingDownloadUrl?: string | null;
      programRating?: number | null;
      fullProgramRatingResponse?: string | null;
      reflectionOnLearnings?: string | null;
      errorDetails?: string | null;
      hangupDetails?: string | null;
      hbacalldata?: Array<string> | null;
      sessionCount?: number | null;
      playlist?: {
        __typename?: "Playlist";
        id: number;
        title: string;
        startOn: string;
        endOn: string;
        isActive: boolean;
      } | null;
    }>;
  };
};

export type GetCallEngagementDurationQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetCallEngagementDurationQuery = { __typename?: "Query"; callDuration: any };

export type UpdateCallRecordMutationVariables = Exact<{
  callSid: Scalars["String"]["input"];
  data: Scalars["JSONObject"]["input"];
}>;

export type UpdateCallRecordMutation = {
  __typename?: "Mutation";
  updateCallRecord: { __typename?: "CallRecord"; sid: string; hbacalldata?: Array<string> | null };
};

export type UpdateSessionCountMutationVariables = Exact<{
  callSid: Scalars["String"]["input"];
  data: Scalars["Float"]["input"];
}>;

export type UpdateSessionCountMutation = {
  __typename?: "Mutation";
  updateSessionCount: { __typename?: "CallRecord"; sid: string; sessionCount?: number | null };
};

export type UpdateHealthieFormMutationVariables = Exact<{
  callSid: Scalars["String"]["input"];
  data: Scalars["JSONObject"]["input"];
}>;

export type UpdateHealthieFormMutation = { __typename?: "Mutation"; updateHealthieForm: any };

export type GetSingleCallRecordQueryVariables = Exact<{
  callSid: Scalars["String"]["input"];
}>;

export type GetSingleCallRecordQuery = {
  __typename?: "Query";
  callRecord: {
    __typename?: "CallRecord";
    hbacalldata?: Array<string> | null;
    sessionCount?: number | null;
    sid: string;
    durationInSeconds?: number | null;
    outcome: CallOutcome;
    type: CallType;
    createdOn: string;
    recordingDownloadUrl?: string | null;
    programRating?: number | null;
    fullProgramRatingResponse?: string | null;
    errorDetails?: string | null;
    hangupDetails?: string | null;
    playlist?: {
      __typename?: "Playlist";
      id: number;
      isActive: boolean;
      startOn: string;
      endOn: string;
      title: string;
      playlistVoiceMessages: Array<{
        __typename?: "PlaylistVoiceMessage";
        voiceMessage: {
          __typename?: "VoiceMessage";
          title?: string | null;
          templateLink?: string | null;
          feature?: string | null;
          cognitiveDomains?: Array<string> | null;
        };
      }>;
    } | null;
    account?: {
      __typename?: "Account";
      firstName: string;
      lastName?: string | null;
      id: number;
      timeZone?: string | null;
      Id_Ehr?: string | null;
    } | null;
  };
};

export type CreateProgramHistoryMutationVariables = Exact<{
  program_type: ProgramType;
  start_date: Scalars["String"]["input"];
  end_date?: InputMaybe<Scalars["String"]["input"]>;
  account_id: Scalars["Int"]["input"];
  specialist_id: Scalars["Int"]["input"];
}>;

export type CreateProgramHistoryMutation = {
  __typename?: "Mutation";
  createProgramHistory: {
    __typename?: "ProgramHistory";
    id: number;
    program_type: string;
    start_date: string;
    end_date?: string | null;
    account_id: number;
    specialistId?: number | null;
  };
};

export type GetProgramEnumsQueryVariables = Exact<{ [key: string]: never }>;

export type GetProgramEnumsQuery = { __typename?: "Query"; programEnums: Array<string> };

export type UpdateProgramHistoryMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  data: UpdateProgramHistoryDto;
}>;

export type UpdateProgramHistoryMutation = {
  __typename?: "Mutation";
  updateProgramHistory: {
    __typename?: "ProgramHistory";
    id: number;
    start_date: string;
    end_date?: string | null;
    round: number;
    specialistId?: number | null;
  };
};

export type UpdateSingleAccountMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  contactPhoneNumber: Scalars["String"]["input"];
  activityPhoneNumber: Scalars["String"]["input"];
  timeZone: Scalars["String"]["input"];
  summary?: InputMaybe<Scalars["String"]["input"]>;
  specialistId: Scalars["Int"]["input"];
  bdlProgramStartOn?: InputMaybe<Scalars["String"]["input"]>;
  bdlProgramEndOn?: InputMaybe<Scalars["String"]["input"]>;
  leadType?: InputMaybe<Scalars["String"]["input"]>;
  Id_Ehr: Scalars["String"]["input"];
}>;

export type UpdateSingleAccountMutation = {
  __typename?: "Mutation";
  updateAccount: {
    __typename?: "Account";
    id: number;
    firstName: string;
    lastName?: string | null;
    contactPhoneNumber?: string | null;
    activityPhoneNumber?: string | null;
    timeZone?: string | null;
    summary?: string | null;
    leadType?: string | null;
    Id_Ehr?: string | null;
    specialist?: {
      __typename?: "User";
      id: number;
      firstName: string;
      lastName?: string | null;
    } | null;
  };
};

export type GetEditUserModalSpecialistsQueryVariables = Exact<{ [key: string]: never }>;

export type GetEditUserModalSpecialistsQuery = {
  __typename?: "Query";
  specialists: Array<{ __typename?: "User"; id: number; firstName: string }>;
};

export type UpdateSingleUserMutationVariables = Exact<{
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  userId: Scalars["Int"]["input"];
  isTestUser: Scalars["Boolean"]["input"];
}>;

export type UpdateSingleUserMutation = {
  __typename?: "Mutation";
  updateUser: {
    __typename?: "User";
    id: number;
    firstName: string;
    lastName?: string | null;
    email?: string | null;
    isTestUser: boolean;
  };
};

export type UploadProfilePhotoSignedUrlQueryVariables = Exact<{
  accountId: Scalars["Int"]["input"];
}>;

export type UploadProfilePhotoSignedUrlQuery = {
  __typename?: "Query";
  uploadProfilePhotoSignedUrl: string;
};

export type GetLatestProgramQueryVariables = Exact<{
  accountId: Scalars["Int"]["input"];
}>;

export type GetLatestProgramQuery = {
  __typename?: "Query";
  getLatestProgram: {
    __typename?: "ProgramHistory";
    id: number;
    program_type: string;
    start_date: string;
    end_date?: string | null;
    round: number;
    created_on: string;
    updated_at: string;
    status?: string | null;
  };
};

export type DeactivateUserMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type DeactivateUserMutation = {
  __typename?: "Mutation";
  deactivateAccount: {
    __typename?: "Account";
    id: number;
    firstName: string;
    lastName?: string | null;
    summary?: string | null;
    timeZone?: string | null;
    createdOn: string;
    updatedOn: string;
  };
};

export type ReactivateUserMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type ReactivateUserMutation = {
  __typename?: "Mutation";
  reactivateAccount: {
    __typename?: "Account";
    id: number;
    firstName: string;
    lastName?: string | null;
    summary?: string | null;
    timeZone?: string | null;
    createdOn: string;
    updatedOn: string;
  };
};

export type GetSingleUserQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
}>;

export type GetSingleUserQuery = {
  __typename?: "Query";
  account: {
    __typename?: "Account";
    id: number;
    firstName: string;
    lastName?: string | null;
    contactPhoneNumber?: string | null;
    activityPhoneNumber?: string | null;
    timeZone?: string | null;
    summary?: string | null;
    programStartOn?: string | null;
    programEndOn?: string | null;
    bdlProgramStartOn?: string | null;
    bdlProgramEndOn?: string | null;
    createdOn: string;
    deletedAt?: string | null;
    profilePhotoUrl?: string | null;
    leadType?: string | null;
    Id_Ehr?: string | null;
    latest_program_type?: string | null;
    user?: {
      __typename?: "User";
      id: number;
      firstName: string;
      lastName?: string | null;
      email?: string | null;
      isTestUser: boolean;
    } | null;
    specialist?: { __typename?: "User"; id: number; firstName: string } | null;
    playlists?: Array<{
      __typename?: "Playlist";
      id: number;
      title: string;
      isActive: boolean;
      startOn: string;
      endOn: string;
      createdOn: string;
      updatedOn: string;
      deletedAt?: string | null;
      program?: {
        __typename?: "ProgramHistory";
        id: number;
        round: number;
        program_type: string;
        start_date: string;
        end_date?: string | null;
      } | null;
      playlistVoiceMessages: Array<{
        __typename?: "PlaylistVoiceMessage";
        id: number;
        order: number;
        createdOn: string;
        updatedOn: string;
        playlist: { __typename?: "Playlist"; id: number; title: string };
        voiceMessage: {
          __typename?: "VoiceMessage";
          id: number;
          title?: string | null;
          feature?: string | null;
          templateLink?: string | null;
          focus?: string | null;
          cognitiveDomains?: Array<string> | null;
          audioFile: { __typename?: "AudioFile"; id: number; durationInSeconds?: number | null };
        };
      }>;
    }> | null;
    callPlans: Array<{
      __typename?: "CallPlan";
      id: number;
      programWeek: number;
      startDate: string;
      endDate?: string | null;
      isActive: boolean;
      program: {
        __typename?: "ProgramHistory";
        id: number;
        round: number;
        program_type: string;
        start_date: string;
        end_date?: string | null;
        status?: string | null;
      };
      interactions?: Array<
        | { __typename?: "ActivityInteraction"; id: number }
        | { __typename?: "OtherInteraction"; id: number }
      > | null;
    }>;
    callRecords?: Array<{
      __typename?: "CallRecord";
      sid: string;
      activities?: Array<{
        __typename?: "ActivityRecord";
        id: number;
        callSid: string;
        voiceMessage: { __typename?: "VoiceMessage"; id: number };
      }> | null;
    }> | null;
    callSchedules?: Array<{
      __typename?: "CallSchedule";
      id: number;
      cronExpression: string;
      scheduleDescription: string;
      callFlowVersion: CallFlowVersion;
      createdOn: string;
    }> | null;
  };
};

export type CreateCallScheduleMutationVariables = Exact<{
  cronExpression: Scalars["String"]["input"];
  accountId: Scalars["Int"]["input"];
  callFlowVersion: CallFlowVersion;
}>;

export type CreateCallScheduleMutation = {
  __typename?: "Mutation";
  createCallSchedule: { __typename?: "CallSchedule"; id: number };
};

export type UpdateCallScheduleMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  cronExpression: Scalars["String"]["input"];
}>;

export type UpdateCallScheduleMutation = {
  __typename?: "Mutation";
  updateCallSchedule: { __typename?: "CallSchedule"; id: number };
};

export type GetDeletedCallSchedulesQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
}>;

export type GetDeletedCallSchedulesQuery = {
  __typename?: "Query";
  deletedCallSchedules: Array<{
    __typename?: "CallSchedule";
    id: number;
    cronExpression: string;
    scheduleDescription: string;
    callFlowVersion: CallFlowVersion;
    createdOn: string;
  }>;
};

export type DeleteCallScheduleMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type DeleteCallScheduleMutation = {
  __typename?: "Mutation";
  deleteCallSchedule: { __typename?: "CallSchedule"; id: number };
};

export type RestoreCallScheduleMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type RestoreCallScheduleMutation = {
  __typename?: "Mutation";
  restoreCallSchedule: { __typename?: "CallSchedule"; id: number };
};

export type GetTranscribeQueryVariables = Exact<{
  callSid: Scalars["String"]["input"];
}>;

export type GetTranscribeQuery = {
  __typename?: "Query";
  transcribe: {
    __typename?: "GetTranscribeReturn";
    code: number;
    message: string;
    data?: any | null;
  };
};

export type SendAccessNotificationMutationVariables = Exact<{
  accountId: Scalars["Int"]["input"];
  accessedBy: Scalars["String"]["input"];
  source: Scalars["String"]["input"];
}>;

export type SendAccessNotificationMutation = {
  __typename?: "Mutation";
  createAccessRecord: { __typename?: "AccessRecord"; id: number };
};

export type OnboardUserSimpleMutationVariables = Exact<{
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  contactPhoneNumber: Scalars["String"]["input"];
  activityPhoneNumber: Scalars["String"]["input"];
  timeZone: Scalars["String"]["input"];
  leadType?: InputMaybe<Scalars["String"]["input"]>;
  specialistId: Scalars["Int"]["input"];
  Id_Ehr: Scalars["String"]["input"];
  isTestUser: Scalars["Boolean"]["input"];
}>;

export type OnboardUserSimpleMutation = {
  __typename?: "Mutation";
  createAccount: { __typename?: "Account"; id: number };
};

export type GetAddUserPopupSpecialistsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAddUserPopupSpecialistsQuery = {
  __typename?: "Query";
  specialists: Array<{ __typename?: "User"; id: number; firstName: string }>;
};

export type GetAllUsersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  take?: InputMaybe<Scalars["Int"]["input"]>;
  isTestUser?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetAllUsersQuery = {
  __typename?: "Query";
  accounts: {
    __typename?: "PaginatedAccounts";
    total: number;
    accounts: Array<{
      __typename?: "Account";
      nextScheduledCall?: string | null;
      id: number;
      firstName: string;
      lastName?: string | null;
      deletedAt?: string | null;
      timeZone?: string | null;
      summary?: string | null;
      leadType?: string | null;
      Id_Ehr?: string | null;
      contactPhoneNumber?: string | null;
      activityPhoneNumber?: string | null;
      bdlProgramStartOn?: string | null;
      bdlProgramEndOn?: string | null;
      latest_program_type?: string | null;
      latest_program_type_status?: string | null;
      programStartOn?: string | null;
      programEndOn?: string | null;
      specialist?: {
        __typename?: "User";
        id: number;
        firstName: string;
        lastName?: string | null;
        email?: string | null;
      } | null;
      user?: {
        __typename?: "User";
        id: number;
        firstName: string;
        lastName?: string | null;
        email?: string | null;
        isTestUser: boolean;
      } | null;
      playlists?: Array<{
        __typename?: "Playlist";
        id: number;
        title: string;
        startOn: string;
        endOn: string;
        isActive: boolean;
        program?: { __typename?: "ProgramHistory"; id: number } | null;
      }> | null;
      latestProgram?: {
        __typename?: "ProgramHistory";
        id: number;
        program_type: string;
        start_date: string;
        end_date?: string | null;
      } | null;
    }>;
  };
};

export type GetFilteredUsersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  take?: InputMaybe<Scalars["Int"]["input"]>;
  isTestUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  specialistId?: InputMaybe<Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]>;
  ProgramType?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
  sortColumn?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<SortOrder>;
  name?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetFilteredUsersQuery = {
  __typename?: "Query";
  accountsWithFilter: {
    __typename?: "PaginatedAccounts";
    total: number;
    accounts: Array<{
      __typename?: "Account";
      nextScheduledCall?: string | null;
      id: number;
      firstName: string;
      lastName?: string | null;
      deletedAt?: string | null;
      timeZone?: string | null;
      summary?: string | null;
      leadType?: string | null;
      Id_Ehr?: string | null;
      contactPhoneNumber?: string | null;
      activityPhoneNumber?: string | null;
      bdlProgramStartOn?: string | null;
      bdlProgramEndOn?: string | null;
      latest_program_type?: string | null;
      latest_program_type_status?: string | null;
      programStartOn?: string | null;
      programEndOn?: string | null;
      specialist?: {
        __typename?: "User";
        id: number;
        firstName: string;
        lastName?: string | null;
        email?: string | null;
      } | null;
      user?: {
        __typename?: "User";
        id: number;
        firstName: string;
        lastName?: string | null;
        email?: string | null;
        isTestUser: boolean;
      } | null;
      playlists?: Array<{
        __typename?: "Playlist";
        id: number;
        title: string;
        startOn: string;
        endOn: string;
        isActive: boolean;
        program?: { __typename?: "ProgramHistory"; id: number } | null;
      }> | null;
      latestProgram?: {
        __typename?: "ProgramHistory";
        id: number;
        program_type: string;
        start_date: string;
        end_date?: string | null;
      } | null;
    }>;
  };
};

export type GetDeactivatedUsersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  take?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetDeactivatedUsersQuery = {
  __typename?: "Query";
  deactivatedAccounts: {
    __typename?: "DeactivatedAccountsResponse";
    totalDeactivatedCount: number;
    deactivatedAccounts: Array<{
      __typename?: "Account";
      id: number;
      firstName: string;
      lastName?: string | null;
      deletedAt?: string | null;
      createdOn: string;
    }>;
  };
};

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>["__apiType"]>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const VoiceMessageInfoFragmentDoc = new TypedDocumentString(
  `
    fragment VoiceMessageInfo on VoiceMessage {
  title
  templateLink
  feature
  cognitiveDomains
}
    `,
  { fragmentName: "VoiceMessageInfo" }
) as unknown as TypedDocumentString<VoiceMessageInfoFragment, unknown>;
export const PlaylistVoiceMessageFragmentDoc = new TypedDocumentString(
  `
    fragment PlaylistVoiceMessage on PlaylistVoiceMessage {
  voiceMessage {
    ...VoiceMessageInfo
  }
}
    fragment VoiceMessageInfo on VoiceMessage {
  title
  templateLink
  feature
  cognitiveDomains
}`,
  { fragmentName: "PlaylistVoiceMessage" }
) as unknown as TypedDocumentString<PlaylistVoiceMessageFragment, unknown>;
export const CallRecordBasicFragmentDoc = new TypedDocumentString(
  `
    fragment CallRecordBasic on CallRecord {
  sid
  durationInSeconds
  outcome
  type
  createdOn
  recordingDownloadUrl
  programRating
  fullProgramRatingResponse
  reflectionOnLearnings
  errorDetails
  hangupDetails
  hbacalldata
  sessionCount
}
    `,
  { fragmentName: "CallRecordBasic" }
) as unknown as TypedDocumentString<CallRecordBasicFragment, unknown>;
export const PlaylistBasicInfoFragmentDoc = new TypedDocumentString(
  `
    fragment PlaylistBasicInfo on Playlist {
  id
  title
  startOn
  endOn
  isActive
}
    `,
  { fragmentName: "PlaylistBasicInfo" }
) as unknown as TypedDocumentString<PlaylistBasicInfoFragment, unknown>;
export const CallRecordWithPlaylistFragmentDoc = new TypedDocumentString(
  `
    fragment CallRecordWithPlaylist on CallRecord {
  ...CallRecordBasic
  playlist {
    ...PlaylistBasicInfo
  }
}
    fragment PlaylistBasicInfo on Playlist {
  id
  title
  startOn
  endOn
  isActive
}
fragment CallRecordBasic on CallRecord {
  sid
  durationInSeconds
  outcome
  type
  createdOn
  recordingDownloadUrl
  programRating
  fullProgramRatingResponse
  reflectionOnLearnings
  errorDetails
  hangupDetails
  hbacalldata
  sessionCount
}`,
  { fragmentName: "CallRecordWithPlaylist" }
) as unknown as TypedDocumentString<CallRecordWithPlaylistFragment, unknown>;
export const AccountBasicInfoFragmentDoc = new TypedDocumentString(
  `
    fragment AccountBasicInfo on Account {
  id
  firstName
  lastName
  deletedAt
  timeZone
  summary
  leadType
  Id_Ehr
  contactPhoneNumber
  activityPhoneNumber
  bdlProgramStartOn
  bdlProgramEndOn
  latest_program_type
  latest_program_type_status
  programStartOn
  programEndOn
}
    `,
  { fragmentName: "AccountBasicInfo" }
) as unknown as TypedDocumentString<AccountBasicInfoFragment, unknown>;
export const SpecialistInfoFragmentDoc = new TypedDocumentString(
  `
    fragment SpecialistInfo on User {
  id
  firstName
  lastName
  email
}
    `,
  { fragmentName: "SpecialistInfo" }
) as unknown as TypedDocumentString<SpecialistInfoFragment, unknown>;
export const UserInfoFragmentDoc = new TypedDocumentString(
  `
    fragment UserInfo on User {
  id
  firstName
  lastName
  email
  isTestUser
}
    `,
  { fragmentName: "UserInfo" }
) as unknown as TypedDocumentString<UserInfoFragment, unknown>;
export const PlaylistWithProgramFragmentDoc = new TypedDocumentString(
  `
    fragment PlaylistWithProgram on Playlist {
  ...PlaylistBasicInfo
  program {
    id
  }
}
    fragment PlaylistBasicInfo on Playlist {
  id
  title
  startOn
  endOn
  isActive
}`,
  { fragmentName: "PlaylistWithProgram" }
) as unknown as TypedDocumentString<PlaylistWithProgramFragment, unknown>;
export const AccountFullInfoFragmentDoc = new TypedDocumentString(
  `
    fragment AccountFullInfo on Account {
  ...AccountBasicInfo
  specialist {
    ...SpecialistInfo
  }
  user {
    ...UserInfo
  }
  playlists {
    ...PlaylistWithProgram
  }
  latestProgram {
    id
    program_type
    start_date
    end_date
  }
}
    fragment AccountBasicInfo on Account {
  id
  firstName
  lastName
  deletedAt
  timeZone
  summary
  leadType
  Id_Ehr
  contactPhoneNumber
  activityPhoneNumber
  bdlProgramStartOn
  bdlProgramEndOn
  latest_program_type
  latest_program_type_status
  programStartOn
  programEndOn
}
fragment UserInfo on User {
  id
  firstName
  lastName
  email
  isTestUser
}
fragment SpecialistInfo on User {
  id
  firstName
  lastName
  email
}
fragment PlaylistBasicInfo on Playlist {
  id
  title
  startOn
  endOn
  isActive
}
fragment PlaylistWithProgram on Playlist {
  ...PlaylistBasicInfo
  program {
    id
  }
}`,
  { fragmentName: "AccountFullInfo" }
) as unknown as TypedDocumentString<AccountFullInfoFragment, unknown>;
export const ProgramHistoryInfoFragmentDoc = new TypedDocumentString(
  `
    fragment ProgramHistoryInfo on ProgramHistory {
  id
  program_type
  start_date
  end_date
  round
  created_on
  updated_at
  status
}
    `,
  { fragmentName: "ProgramHistoryInfo" }
) as unknown as TypedDocumentString<ProgramHistoryInfoFragment, unknown>;
export const ProgramHistoryWithSpecialistFragmentDoc = new TypedDocumentString(
  `
    fragment ProgramHistoryWithSpecialist on ProgramHistory {
  ...ProgramHistoryInfo
  specialist {
    ...SpecialistInfo
  }
}
    fragment SpecialistInfo on User {
  id
  firstName
  lastName
  email
}
fragment ProgramHistoryInfo on ProgramHistory {
  id
  program_type
  start_date
  end_date
  round
  created_on
  updated_at
  status
}`,
  { fragmentName: "ProgramHistoryWithSpecialist" }
) as unknown as TypedDocumentString<ProgramHistoryWithSpecialistFragment, unknown>;
export const VoiceMessageDetailedFragmentDoc = new TypedDocumentString(
  `
    fragment VoiceMessageDetailed on VoiceMessage {
  id
  title
  feature
  templateLink
  focus
  cognitiveDomains
  audioFile {
    id
    durationInSeconds
  }
}
    `,
  { fragmentName: "VoiceMessageDetailed" }
) as unknown as TypedDocumentString<VoiceMessageDetailedFragment, unknown>;
export const PlaylistVoiceMessageDetailedFragmentDoc = new TypedDocumentString(
  `
    fragment PlaylistVoiceMessageDetailed on PlaylistVoiceMessage {
  id
  order
  createdOn
  updatedOn
  playlist {
    id
    title
  }
  voiceMessage {
    ...VoiceMessageDetailed
  }
}
    fragment VoiceMessageDetailed on VoiceMessage {
  id
  title
  feature
  templateLink
  focus
  cognitiveDomains
  audioFile {
    id
    durationInSeconds
  }
}`,
  { fragmentName: "PlaylistVoiceMessageDetailed" }
) as unknown as TypedDocumentString<PlaylistVoiceMessageDetailedFragment, unknown>;
export const PlaylistDetailedFragmentDoc = new TypedDocumentString(
  `
    fragment PlaylistDetailed on Playlist {
  id
  title
  isActive
  startOn
  endOn
  createdOn
  updatedOn
  deletedAt
  program {
    id
    round
    program_type
    start_date
    end_date
  }
  playlistVoiceMessages {
    ...PlaylistVoiceMessageDetailed
  }
}
    fragment VoiceMessageDetailed on VoiceMessage {
  id
  title
  feature
  templateLink
  focus
  cognitiveDomains
  audioFile {
    id
    durationInSeconds
  }
}
fragment PlaylistVoiceMessageDetailed on PlaylistVoiceMessage {
  id
  order
  createdOn
  updatedOn
  playlist {
    id
    title
  }
  voiceMessage {
    ...VoiceMessageDetailed
  }
}`,
  { fragmentName: "PlaylistDetailed" }
) as unknown as TypedDocumentString<PlaylistDetailedFragment, unknown>;
export const CallPlanInfoFragmentDoc = new TypedDocumentString(
  `
    fragment CallPlanInfo on CallPlan {
  id
  programWeek
  startDate
  endDate
  isActive
  program {
    id
    round
    program_type
    start_date
    end_date
    status
  }
  interactions {
    id
  }
}
    `,
  { fragmentName: "CallPlanInfo" }
) as unknown as TypedDocumentString<CallPlanInfoFragment, unknown>;
export const CallScheduleInfoFragmentDoc = new TypedDocumentString(
  `
    fragment CallScheduleInfo on CallSchedule {
  id
  cronExpression
  scheduleDescription
  callFlowVersion
  createdOn
}
    `,
  { fragmentName: "CallScheduleInfo" }
) as unknown as TypedDocumentString<CallScheduleInfoFragment, unknown>;
export const GetSingleUserAccountFragmentDoc = new TypedDocumentString(
  `
    fragment GetSingleUserAccount on Account {
  id
  firstName
  lastName
  contactPhoneNumber
  activityPhoneNumber
  timeZone
  summary
  programStartOn
  programEndOn
  bdlProgramStartOn
  bdlProgramEndOn
  createdOn
  deletedAt
  profilePhotoUrl
  leadType
  Id_Ehr
  latest_program_type
  user {
    ...UserInfo
  }
  specialist {
    id
    firstName
  }
  playlists {
    ...PlaylistDetailed
  }
  callPlans {
    ...CallPlanInfo
  }
  callRecords {
    sid
    activities {
      id
      callSid
      voiceMessage {
        id
      }
    }
  }
  callSchedules {
    ...CallScheduleInfo
  }
}
    fragment UserInfo on User {
  id
  firstName
  lastName
  email
  isTestUser
}
fragment VoiceMessageDetailed on VoiceMessage {
  id
  title
  feature
  templateLink
  focus
  cognitiveDomains
  audioFile {
    id
    durationInSeconds
  }
}
fragment PlaylistVoiceMessageDetailed on PlaylistVoiceMessage {
  id
  order
  createdOn
  updatedOn
  playlist {
    id
    title
  }
  voiceMessage {
    ...VoiceMessageDetailed
  }
}
fragment PlaylistDetailed on Playlist {
  id
  title
  isActive
  startOn
  endOn
  createdOn
  updatedOn
  deletedAt
  program {
    id
    round
    program_type
    start_date
    end_date
  }
  playlistVoiceMessages {
    ...PlaylistVoiceMessageDetailed
  }
}
fragment CallPlanInfo on CallPlan {
  id
  programWeek
  startDate
  endDate
  isActive
  program {
    id
    round
    program_type
    start_date
    end_date
    status
  }
  interactions {
    id
  }
}
fragment CallScheduleInfo on CallSchedule {
  id
  cronExpression
  scheduleDescription
  callFlowVersion
  createdOn
}`,
  { fragmentName: "GetSingleUserAccount" }
) as unknown as TypedDocumentString<GetSingleUserAccountFragment, unknown>;
export const AllFeaturesDocument = new TypedDocumentString(`
    query AllFeatures {
  features {
    featureName
    enabled
    treatment
  }
}
    `) as unknown as TypedDocumentString<AllFeaturesQuery, AllFeaturesQueryVariables>;
export const ExpireRefreshTokenDocument = new TypedDocumentString(`
    mutation expireRefreshToken($userId: String!) {
  expireRefreshToken(data: {userId: $userId}) {
    done
  }
}
    `) as unknown as TypedDocumentString<
  ExpireRefreshTokenMutation,
  ExpireRefreshTokenMutationVariables
>;
export const QuerySpecialistsDropdownDocument = new TypedDocumentString(`
    query QuerySpecialistsDropdown {
  specialists {
    ...SpecialistInfo
  }
}
    fragment SpecialistInfo on User {
  id
  firstName
  lastName
  email
}`) as unknown as TypedDocumentString<
  QuerySpecialistsDropdownQuery,
  QuerySpecialistsDropdownQueryVariables
>;
export const GetAccessNotificationsDocument = new TypedDocumentString(`
    query GetAccessNotifications($startDate: String, $endDate: String, $accountId: Int) {
  accessRecords(
    data: {startDate: $startDate, endDate: $endDate, accountId: $accountId}
  ) {
    id
    accessedBy
    account {
      id
      firstName
      lastName
    }
    source
    createdOn
    updatedOn
  }
}
    `) as unknown as TypedDocumentString<
  GetAccessNotificationsQuery,
  GetAccessNotificationsQueryVariables
>;
export const GetSingleActivityDocument = new TypedDocumentString(`
    query GetSingleActivity($id: Int!) {
  voiceMessage(id: $id) {
    id
    title
    templateLink
    feature
    focus
    difficulty
    cognitiveDomains
    inLibrary
    createdOn
    deletedAt
    recordedBy {
      id
    }
    deactivationNote
    audioFile {
      id
      durationInSeconds
      filename
      downloadUrl
    }
  }
}
    `) as unknown as TypedDocumentString<GetSingleActivityQuery, GetSingleActivityQueryVariables>;
export const UpdateVoiceMessageDocument = new TypedDocumentString(`
    mutation UpdateVoiceMessage($id: Int!, $title: String!, $templateLink: String, $feature: String, $focus: String, $inLibrary: Boolean, $recordedById: Int!, $cognitiveDomains: [String!], $difficulty: DifficultyType) {
  updateVoiceMessage(
    id: $id
    data: {title: $title, templateLink: $templateLink, feature: $feature, focus: $focus, inLibrary: $inLibrary, recordedById: $recordedById, cognitiveDomains: $cognitiveDomains, difficulty: $difficulty}
  ) {
    id
    title
    templateLink
    feature
    focus
    cognitiveDomains
    difficulty
    createdOn
    recordedBy {
      id
    }
    audioFile {
      id
      durationInSeconds
      filename
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpdateVoiceMessageMutation,
  UpdateVoiceMessageMutationVariables
>;
export const SetVoiceMessageActivationDocument = new TypedDocumentString(`
    mutation SetVoiceMessageActivation($id: Int!, $isActive: Boolean!, $deactivationNote: String) {
  setVoiceMessageActivation(
    id: $id
    isActive: $isActive
    deactivateDto: {deactivationNote: $deactivationNote}
  ) {
    id
    deletedAt
    createdOn
    recordedBy {
      id
    }
    audioFile {
      durationInSeconds
      filename
    }
  }
}
    `) as unknown as TypedDocumentString<
  SetVoiceMessageActivationMutation,
  SetVoiceMessageActivationMutationVariables
>;
export const GetAllActivitiesDocument = new TypedDocumentString(`
    query GetAllActivities($take: Int, $skip: Int, $inLibrary: Boolean, $statusView: StatusView, $cognitiveDomain: CognitiveDomain, $feature: Feature) {
  voiceMessages(
    data: {take: $take, skip: $skip, inLibrary: $inLibrary, statusView: $statusView, cognitiveDomain: $cognitiveDomain, feature: $feature}
  ) {
    count
    data {
      id
      title
      templateLink
      category
      feature
      focus
      cognitiveDomains
      deletedAt
      createdOn
      difficulty
      recordedBy {
        id
      }
      audioFile {
        id
        durationInSeconds
        filename
        downloadUrl
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAllActivitiesQuery, GetAllActivitiesQueryVariables>;
export const UploadVoiceMessageDocument = new TypedDocumentString(`
    mutation UploadVoiceMessage($file: Upload!, $durationInSeconds: Int!) {
  uploadVoiceMessage(file: $file, durationInSeconds: $durationInSeconds) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  UploadVoiceMessageMutation,
  UploadVoiceMessageMutationVariables
>;
export const GetDifficultyEnumsDocument = new TypedDocumentString(`
    query GetDifficultyEnums {
  difficultyEnums
}
    `) as unknown as TypedDocumentString<GetDifficultyEnumsQuery, GetDifficultyEnumsQueryVariables>;
export const GetQuestionTypesDocument = new TypedDocumentString(`
    query GetQuestionTypes {
  questionTypes {
    id
    questionTypeDescription
    questionTypeKey
    questionTypeLabel
  }
}
    `) as unknown as TypedDocumentString<GetQuestionTypesQuery, GetQuestionTypesQueryVariables>;
export const GetDraftActivitiesDocument = new TypedDocumentString(`
    query GetDraftActivities($filter: String) {
  draftActivities(filter: $filter) {
    id
    title
    activityJSON
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetDraftActivitiesQuery, GetDraftActivitiesQueryVariables>;
export const UpsertDraftActivityDocument = new TypedDocumentString(`
    mutation UpsertDraftActivity($activityJSON: JSONObject!, $id: Int) {
  upsertDraftActivity(activityJSON: $activityJSON, id: $id) {
    id
    title
    activityJSON
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<
  UpsertDraftActivityMutation,
  UpsertDraftActivityMutationVariables
>;
export const CreateFeedbackDocument = new TypedDocumentString(`
    mutation CreateFeedback($data: createFeedbackDto!) {
  createFeedback(data: $data) {
    id
    callSid
    rating
    reason
    description
    createdAt
    updatedAt
    createdBy
  }
}
    `) as unknown as TypedDocumentString<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const GetFeedbackDocument = new TypedDocumentString(`
    query GetFeedback($id: String!) {
  getFeedback(id: $id) {
    id
    callSid
    rating
    reason
    description
    createdAt
    updatedAt
    createdBy
  }
}
    `) as unknown as TypedDocumentString<GetFeedbackQuery, GetFeedbackQueryVariables>;
export const GetFeedbacksDocument = new TypedDocumentString(`
    query GetFeedbacks($createdBy: String, $rating: Float) {
  getFeedbacks(createdBy: $createdBy, rating: $rating) {
    id
    callSid
    rating
    reason
    description
    createdAt
    updatedAt
    createdBy
  }
}
    `) as unknown as TypedDocumentString<GetFeedbacksQuery, GetFeedbacksQueryVariables>;
export const UpdateFeedbackDocument = new TypedDocumentString(`
    mutation UpdateFeedback($data: updateFeedbackDto!) {
  updateFeedback(data: $data) {
    id
    callSid
    rating
    reason
    description
    createdAt
    updatedAt
    createdBy
  }
}
    `) as unknown as TypedDocumentString<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>;
export const ChangePasswordDocument = new TypedDocumentString(`
    mutation ChangePassword($username: String!, $PreviousPassword: String!, $ProposedPassword: String!) {
  changePassword(
    data: {username: $username, PreviousPassword: $PreviousPassword, ProposedPassword: $ProposedPassword}
  ) {
    done
  }
}
    `) as unknown as TypedDocumentString<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const GetUserNotificationPreferenceDocument = new TypedDocumentString(`
    query GetUserNotificationPreference($userId: Int!) {
  userNotificationPreference(userId: $userId) {
    userId
    emailEnabled
  }
}
    `) as unknown as TypedDocumentString<
  GetUserNotificationPreferenceQuery,
  GetUserNotificationPreferenceQueryVariables
>;
export const UpdateUserNotificationPreferencesDocument = new TypedDocumentString(`
    mutation UpdateUserNotificationPreferences($userId: Int!, $input: UpdateNotificationPreferenceDto!) {
  updateUserNotificationPreferences(userId: $userId, input: $input) {
    id
    emailEnabled
  }
}
    `) as unknown as TypedDocumentString<
  UpdateUserNotificationPreferencesMutation,
  UpdateUserNotificationPreferencesMutationVariables
>;
export const GetSingleDeactivatedUserDocument = new TypedDocumentString(`
    query GetSingleDeactivatedUser($userId: Int!) {
  deactivatedAccount(id: $userId) {
    id
    firstName
    lastName
    contactPhoneNumber
    activityPhoneNumber
    timeZone
    summary
    programStartOn
    programEndOn
    createdOn
    deletedAt
  }
}
    `) as unknown as TypedDocumentString<
  GetSingleDeactivatedUserQuery,
  GetSingleDeactivatedUserQueryVariables
>;
export const GetLoginDocument = new TypedDocumentString(`
    mutation getLogin($username: String!, $password: String!) {
  login(data: {username: $username, password: $password}) {
    accessToken
    refreshToken
    idToken
    isValid
    lastPass
  }
}
    `) as unknown as TypedDocumentString<GetLoginMutation, GetLoginMutationVariables>;
export const GetOtpDocument = new TypedDocumentString(`
    mutation getOtp($userId: String!, $method: String!) {
  getOtp(data: {userId: $userId, method: $method}) {
    done
    message
  }
}
    `) as unknown as TypedDocumentString<GetOtpMutation, GetOtpMutationVariables>;
export const VerifyOtpDocument = new TypedDocumentString(`
    mutation verifyOtp($userId: String!, $code: String!) {
  verifyOtp(data: {userId: $userId, code: $code}) {
    done
    message
  }
}
    `) as unknown as TypedDocumentString<VerifyOtpMutation, VerifyOtpMutationVariables>;
export const UpdatePhoneNumberDocument = new TypedDocumentString(`
    mutation updatePhoneNumber($userId: String!, $phoneNumber: String!) {
  updatePhoneNumber(data: {userId: $userId, phoneNumber: $phoneNumber}) {
    done
  }
}
    `) as unknown as TypedDocumentString<
  UpdatePhoneNumberMutation,
  UpdatePhoneNumberMutationVariables
>;
export const GetActivitiesDocument = new TypedDocumentString(`
    query GetActivities($accountId: Int, $skip: Int, $take: Int, $filters: ActivityListFiltersInput, $sort: ActivityListSortInput) {
  activities(
    accountId: $accountId
    skip: $skip
    take: $take
    filters: $filters
    sort: $sort
  ) {
    total
    activities {
      id
      title
      category
      difficulty
      lastDeliveryTime(accountId: $accountId)
      earliestFutureCallPlan(accountId: $accountId) {
        id
        programWeek
        startDate
        endDate
      }
      activityTypes {
        activityTypeKey
        activityTypeLabel
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetActivitiesQuery, GetActivitiesQueryVariables>;
export const GetActivityTypesDocument = new TypedDocumentString(`
    query GetActivityTypes {
  activityTypes {
    activityTypeKey
    activityTypeLabel
    displayOrder
  }
}
    `) as unknown as TypedDocumentString<GetActivityTypesQuery, GetActivityTypesQueryVariables>;
export const GetActivityDocument = new TypedDocumentString(`
    query GetActivity($id: Int!) {
  activity(id: $id) {
    id
    title
    description
    contents {
      id
      sequenceOrder
      readableText
      ... on QuestionActivityContent {
        questionTypeLabel
        expectedAnswers {
          id
          expectedAnswerText
        }
      }
    }
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `) as unknown as TypedDocumentString<GetActivityQuery, GetActivityQueryVariables>;
export const CreateCallPlanDocument = new TypedDocumentString(`
    mutation CreateCallPlan($input: CreateCallPlanInput!) {
  createCallPlan(input: $input) {
    ...CallPlanInfo
  }
}
    fragment CallPlanInfo on CallPlan {
  id
  programWeek
  startDate
  endDate
  isActive
  program {
    id
    round
    program_type
    start_date
    end_date
    status
  }
  interactions {
    id
  }
}`) as unknown as TypedDocumentString<CreateCallPlanMutation, CreateCallPlanMutationVariables>;
export const UpdateCallPlanDocument = new TypedDocumentString(`
    mutation UpdateCallPlan($input: UpdateCallPlanInput!) {
  updateCallPlan(input: $input) {
    ...CallPlanInfo
  }
}
    fragment CallPlanInfo on CallPlan {
  id
  programWeek
  startDate
  endDate
  isActive
  program {
    id
    round
    program_type
    start_date
    end_date
    status
  }
  interactions {
    id
  }
}`) as unknown as TypedDocumentString<UpdateCallPlanMutation, UpdateCallPlanMutationVariables>;
export const DeleteCallPlanDocument = new TypedDocumentString(`
    mutation DeleteCallPlan($id: Int!) {
  deleteCallPlan(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteCallPlanMutation, DeleteCallPlanMutationVariables>;
export const GetCallPlanActivitiesDocument = new TypedDocumentString(`
    query GetCallPlanActivities($callPlanId: Int!) {
  callPlan(id: $callPlanId) {
    id
    interactions {
      id
      order
      ... on ActivityInteraction {
        activityId
        title
        category
        difficulty
        activityTypes {
          activityTypeKey
          activityTypeLabel
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetCallPlanActivitiesQuery,
  GetCallPlanActivitiesQueryVariables
>;
export const GetCallPlanDetailDocument = new TypedDocumentString(`
    query GetCallPlanDetail($callPlanId: Int!) {
  callPlan(id: $callPlanId) {
    id
    programWeek
    startDate
    endDate
    isActive
    program {
      id
      round
      program_type
      start_date
      end_date
    }
    interactions {
      id
      order
      skippable
      ... on OtherInteraction {
        type
        contentText
      }
      ... on ActivityInteraction {
        activityId
        title
        description
        estimatedDuration
        contents {
          id
          sequenceOrder
          readableText
          ... on QuestionActivityContent {
            questionTypeLabel
            responseTimeLimitSec
            silenceBeforeResponseSec
            expectedAnswers {
              id
              expectedAnswerText
            }
          }
        }
        voiceMessage {
          id
          audioFile {
            durationInSeconds
          }
          recordedBy {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCallPlanDetailQuery, GetCallPlanDetailQueryVariables>;
export const CreatePlaylistDocument = new TypedDocumentString(`
    mutation CreatePlaylist($accountId: Int!, $title: String!, $voiceMessageIds: [Int!]!, $startOn: String!, $endOn: String!, $isFreeTrial: Boolean!, $isTracked: Boolean!) {
  createPlaylist(
    data: {accountId: $accountId, title: $title, voiceMessageIds: $voiceMessageIds, startOn: $startOn, endOn: $endOn, isFreeTrial: $isFreeTrial, isTracked: $isTracked}
  ) {
    id
    title
    startOn
    endOn
    createdOn
    updatedOn
    program {
      id
      round
      program_type
    }
  }
}
    `) as unknown as TypedDocumentString<CreatePlaylistMutation, CreatePlaylistMutationVariables>;
export const GetSinglePlaylistDocument = new TypedDocumentString(`
    query GetSinglePlaylist($id: Int!) {
  playlist(id: $id) {
    id
    title
    isActive
    startOn
    endOn
    createdOn
    updatedOn
    deletedAt
    isFreeTrial
    isTracked
    account {
      id
      firstName
      lastName
      timeZone
    }
    program {
      id
      program_type
      round
    }
    playlistVoiceMessages {
      id
      order
      voiceMessage {
        id
        title
        feature
        focus
        templateLink
        cognitiveDomains
        createdOn
        audioFile {
          id
          durationInSeconds
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetSinglePlaylistQuery, GetSinglePlaylistQueryVariables>;
export const UpdateSinglePlaylistDocument = new TypedDocumentString(`
    mutation UpdateSinglePlaylist($id: Int!, $title: String, $voiceMessageIds: [Int!], $startOn: String, $endOn: String, $isFreeTrial: Boolean, $isTracked: Boolean, $programId: Int) {
  updatePlaylist(
    data: {id: $id, title: $title, voiceMessageIds: $voiceMessageIds, startOn: $startOn, endOn: $endOn, isFreeTrial: $isFreeTrial, isTracked: $isTracked, programId: $programId}
  ) {
    id
    title
    startOn
    endOn
    createdOn
    updatedOn
  }
}
    `) as unknown as TypedDocumentString<
  UpdateSinglePlaylistMutation,
  UpdateSinglePlaylistMutationVariables
>;
export const DeleteSinglePlaylistDocument = new TypedDocumentString(`
    mutation DeleteSinglePlaylist($id: Int!) {
  deletePlaylist(id: $id) {
    id
    title
    startOn
    endOn
    createdOn
    updatedOn
  }
}
    `) as unknown as TypedDocumentString<
  DeleteSinglePlaylistMutation,
  DeleteSinglePlaylistMutationVariables
>;
export const GetTreatmentHistoryDocument = new TypedDocumentString(`
    query GetTreatmentHistory($accountId: Int!) {
  treatmentHistory: programHistory(account_id: $accountId) {
    ...ProgramHistoryWithSpecialist
  }
}
    fragment SpecialistInfo on User {
  id
  firstName
  lastName
  email
}
fragment ProgramHistoryInfo on ProgramHistory {
  id
  program_type
  start_date
  end_date
  round
  created_on
  updated_at
  status
}
fragment ProgramHistoryWithSpecialist on ProgramHistory {
  ...ProgramHistoryInfo
  specialist {
    ...SpecialistInfo
  }
}`) as unknown as TypedDocumentString<GetTreatmentHistoryQuery, GetTreatmentHistoryQueryVariables>;
export const GetCallRecordsDocument = new TypedDocumentString(`
    query GetCallRecords($take: Int, $skip: Int, $sortDirection: SortingDirection, $accountId: Int, $minDuration: Int, $playlistId: Int) {
  callRecords(
    data: {take: $take, skip: $skip, sortDirection: $sortDirection, accountId: $accountId, minDuration: $minDuration, playlistId: $playlistId}
  ) {
    count
    thisWeek
    lastWeek
    activitiesPlayed
    month
    data {
      ...CallRecordWithPlaylist
    }
  }
}
    fragment PlaylistBasicInfo on Playlist {
  id
  title
  startOn
  endOn
  isActive
}
fragment CallRecordBasic on CallRecord {
  sid
  durationInSeconds
  outcome
  type
  createdOn
  recordingDownloadUrl
  programRating
  fullProgramRatingResponse
  reflectionOnLearnings
  errorDetails
  hangupDetails
  hbacalldata
  sessionCount
}
fragment CallRecordWithPlaylist on CallRecord {
  ...CallRecordBasic
  playlist {
    ...PlaylistBasicInfo
  }
}`) as unknown as TypedDocumentString<GetCallRecordsQuery, GetCallRecordsQueryVariables>;
export const GetCallEngagementDurationDocument = new TypedDocumentString(`
    query GetCallEngagementDuration($accountId: Int) {
  callDuration(data: {accountId: $accountId})
}
    `) as unknown as TypedDocumentString<
  GetCallEngagementDurationQuery,
  GetCallEngagementDurationQueryVariables
>;
export const UpdateCallRecordDocument = new TypedDocumentString(`
    mutation UpdateCallRecord($callSid: String!, $data: JSONObject!) {
  updateCallRecord(callSid: $callSid, data: $data) {
    sid
    hbacalldata
  }
}
    `) as unknown as TypedDocumentString<
  UpdateCallRecordMutation,
  UpdateCallRecordMutationVariables
>;
export const UpdateSessionCountDocument = new TypedDocumentString(`
    mutation UpdateSessionCount($callSid: String!, $data: Float!) {
  updateSessionCount(callSid: $callSid, data: $data) {
    sid
    sessionCount
  }
}
    `) as unknown as TypedDocumentString<
  UpdateSessionCountMutation,
  UpdateSessionCountMutationVariables
>;
export const UpdateHealthieFormDocument = new TypedDocumentString(`
    mutation UpdateHealthieForm($callSid: String!, $data: JSONObject!) {
  updateHealthieForm(callSid: $callSid, data: $data)
}
    `) as unknown as TypedDocumentString<
  UpdateHealthieFormMutation,
  UpdateHealthieFormMutationVariables
>;
export const GetSingleCallRecordDocument = new TypedDocumentString(`
    query GetSingleCallRecord($callSid: String!) {
  callRecord(callSid: $callSid) {
    hbacalldata
    sessionCount
    sid
    durationInSeconds
    outcome
    type
    createdOn
    recordingDownloadUrl
    programRating
    fullProgramRatingResponse
    errorDetails
    hangupDetails
    playlist {
      id
      isActive
      startOn
      endOn
      title
      playlistVoiceMessages {
        voiceMessage {
          title
          templateLink
          feature
          cognitiveDomains
        }
      }
    }
    account {
      firstName
      lastName
      id
      timeZone
      Id_Ehr
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetSingleCallRecordQuery,
  GetSingleCallRecordQueryVariables
>;
export const CreateProgramHistoryDocument = new TypedDocumentString(`
    mutation CreateProgramHistory($program_type: ProgramType!, $start_date: String!, $end_date: String, $account_id: Int!, $specialist_id: Int!) {
  createProgramHistory(
    data: {program_type: $program_type, start_date: $start_date, end_date: $end_date, account_id: $account_id, specialist_id: $specialist_id}
  ) {
    id
    program_type
    start_date
    end_date
    account_id
    specialistId
  }
}
    `) as unknown as TypedDocumentString<
  CreateProgramHistoryMutation,
  CreateProgramHistoryMutationVariables
>;
export const GetProgramEnumsDocument = new TypedDocumentString(`
    query GetProgramEnums {
  programEnums
}
    `) as unknown as TypedDocumentString<GetProgramEnumsQuery, GetProgramEnumsQueryVariables>;
export const UpdateProgramHistoryDocument = new TypedDocumentString(`
    mutation updateProgramHistory($id: Int!, $data: UpdateProgramHistoryDto!) {
  updateProgramHistory(id: $id, data: $data) {
    id
    start_date
    end_date
    round
    specialistId
  }
}
    `) as unknown as TypedDocumentString<
  UpdateProgramHistoryMutation,
  UpdateProgramHistoryMutationVariables
>;
export const UpdateSingleAccountDocument = new TypedDocumentString(`
    mutation UpdateSingleAccount($id: Int!, $firstName: String!, $lastName: String!, $contactPhoneNumber: String!, $activityPhoneNumber: String!, $timeZone: String!, $summary: String, $specialistId: Int!, $bdlProgramStartOn: String, $bdlProgramEndOn: String, $leadType: String, $Id_Ehr: String!) {
  updateAccount(
    data: {id: $id, firstName: $firstName, lastName: $lastName, contactPhoneNumber: $contactPhoneNumber, activityPhoneNumber: $activityPhoneNumber, timeZone: $timeZone, summary: $summary, specialistId: $specialistId, bdlProgramStartOn: $bdlProgramStartOn, bdlProgramEndOn: $bdlProgramEndOn, leadType: $leadType, Id_Ehr: $Id_Ehr}
  ) {
    id
    firstName
    lastName
    contactPhoneNumber
    activityPhoneNumber
    specialist {
      id
      firstName
      lastName
    }
    timeZone
    summary
    leadType
    Id_Ehr
  }
}
    `) as unknown as TypedDocumentString<
  UpdateSingleAccountMutation,
  UpdateSingleAccountMutationVariables
>;
export const GetEditUserModalSpecialistsDocument = new TypedDocumentString(`
    query GetEditUserModalSpecialists {
  specialists {
    id
    firstName
  }
}
    `) as unknown as TypedDocumentString<
  GetEditUserModalSpecialistsQuery,
  GetEditUserModalSpecialistsQueryVariables
>;
export const UpdateSingleUserDocument = new TypedDocumentString(`
    mutation UpdateSingleUser($firstName: String!, $lastName: String!, $userId: Int!, $isTestUser: Boolean!) {
  updateUser(
    data: {id: $userId, firstName: $firstName, lastName: $lastName, isTestUser: $isTestUser}
  ) {
    id
    firstName
    lastName
    email
    isTestUser
  }
}
    `) as unknown as TypedDocumentString<
  UpdateSingleUserMutation,
  UpdateSingleUserMutationVariables
>;
export const UploadProfilePhotoSignedUrlDocument = new TypedDocumentString(`
    query uploadProfilePhotoSignedUrl($accountId: Int!) {
  uploadProfilePhotoSignedUrl(accountId: $accountId)
}
    `) as unknown as TypedDocumentString<
  UploadProfilePhotoSignedUrlQuery,
  UploadProfilePhotoSignedUrlQueryVariables
>;
export const GetLatestProgramDocument = new TypedDocumentString(`
    query GetLatestProgram($accountId: Int!) {
  getLatestProgram(account_id: $accountId) {
    ...ProgramHistoryInfo
  }
}
    fragment ProgramHistoryInfo on ProgramHistory {
  id
  program_type
  start_date
  end_date
  round
  created_on
  updated_at
  status
}`) as unknown as TypedDocumentString<GetLatestProgramQuery, GetLatestProgramQueryVariables>;
export const DeactivateUserDocument = new TypedDocumentString(`
    mutation DeactivateUser($id: Int!) {
  deactivateAccount(id: $id) {
    id
    firstName
    lastName
    summary
    timeZone
    createdOn
    updatedOn
  }
}
    `) as unknown as TypedDocumentString<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const ReactivateUserDocument = new TypedDocumentString(`
    mutation ReactivateUser($id: Int!) {
  reactivateAccount(id: $id) {
    id
    firstName
    lastName
    summary
    timeZone
    createdOn
    updatedOn
  }
}
    `) as unknown as TypedDocumentString<ReactivateUserMutation, ReactivateUserMutationVariables>;
export const GetSingleUserDocument = new TypedDocumentString(`
    query GetSingleUser($userId: Int!) {
  account(id: $userId) {
    ...GetSingleUserAccount
  }
}
    fragment UserInfo on User {
  id
  firstName
  lastName
  email
  isTestUser
}
fragment VoiceMessageDetailed on VoiceMessage {
  id
  title
  feature
  templateLink
  focus
  cognitiveDomains
  audioFile {
    id
    durationInSeconds
  }
}
fragment PlaylistVoiceMessageDetailed on PlaylistVoiceMessage {
  id
  order
  createdOn
  updatedOn
  playlist {
    id
    title
  }
  voiceMessage {
    ...VoiceMessageDetailed
  }
}
fragment PlaylistDetailed on Playlist {
  id
  title
  isActive
  startOn
  endOn
  createdOn
  updatedOn
  deletedAt
  program {
    id
    round
    program_type
    start_date
    end_date
  }
  playlistVoiceMessages {
    ...PlaylistVoiceMessageDetailed
  }
}
fragment CallPlanInfo on CallPlan {
  id
  programWeek
  startDate
  endDate
  isActive
  program {
    id
    round
    program_type
    start_date
    end_date
    status
  }
  interactions {
    id
  }
}
fragment CallScheduleInfo on CallSchedule {
  id
  cronExpression
  scheduleDescription
  callFlowVersion
  createdOn
}
fragment GetSingleUserAccount on Account {
  id
  firstName
  lastName
  contactPhoneNumber
  activityPhoneNumber
  timeZone
  summary
  programStartOn
  programEndOn
  bdlProgramStartOn
  bdlProgramEndOn
  createdOn
  deletedAt
  profilePhotoUrl
  leadType
  Id_Ehr
  latest_program_type
  user {
    ...UserInfo
  }
  specialist {
    id
    firstName
  }
  playlists {
    ...PlaylistDetailed
  }
  callPlans {
    ...CallPlanInfo
  }
  callRecords {
    sid
    activities {
      id
      callSid
      voiceMessage {
        id
      }
    }
  }
  callSchedules {
    ...CallScheduleInfo
  }
}`) as unknown as TypedDocumentString<GetSingleUserQuery, GetSingleUserQueryVariables>;
export const CreateCallScheduleDocument = new TypedDocumentString(`
    mutation CreateCallSchedule($cronExpression: String!, $accountId: Int!, $callFlowVersion: CallFlowVersion!) {
  createCallSchedule(
    data: {cronExpression: $cronExpression, accountId: $accountId, callFlowVersion: $callFlowVersion}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  CreateCallScheduleMutation,
  CreateCallScheduleMutationVariables
>;
export const UpdateCallScheduleDocument = new TypedDocumentString(`
    mutation UpdateCallSchedule($id: Int!, $cronExpression: String!) {
  updateCallSchedule(id: $id, data: {cronExpression: $cronExpression}) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  UpdateCallScheduleMutation,
  UpdateCallScheduleMutationVariables
>;
export const GetDeletedCallSchedulesDocument = new TypedDocumentString(`
    query GetDeletedCallSchedules($userId: Int!) {
  deletedCallSchedules(accountId: $userId) {
    id
    cronExpression
    scheduleDescription
    callFlowVersion
    createdOn
  }
}
    `) as unknown as TypedDocumentString<
  GetDeletedCallSchedulesQuery,
  GetDeletedCallSchedulesQueryVariables
>;
export const DeleteCallScheduleDocument = new TypedDocumentString(`
    mutation DeleteCallSchedule($id: Int!) {
  deleteCallSchedule(id: $id) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  DeleteCallScheduleMutation,
  DeleteCallScheduleMutationVariables
>;
export const RestoreCallScheduleDocument = new TypedDocumentString(`
    mutation RestoreCallSchedule($id: Int!) {
  restoreCallSchedule(id: $id) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  RestoreCallScheduleMutation,
  RestoreCallScheduleMutationVariables
>;
export const GetTranscribeDocument = new TypedDocumentString(`
    query GetTranscribe($callSid: String!) {
  transcribe(callSid: $callSid) {
    code
    message
    data
  }
}
    `) as unknown as TypedDocumentString<GetTranscribeQuery, GetTranscribeQueryVariables>;
export const SendAccessNotificationDocument = new TypedDocumentString(`
    mutation SendAccessNotification($accountId: Int!, $accessedBy: String!, $source: String!) {
  createAccessRecord(
    data: {accountId: $accountId, accessedBy: $accessedBy, source: $source}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  SendAccessNotificationMutation,
  SendAccessNotificationMutationVariables
>;
export const OnboardUserSimpleDocument = new TypedDocumentString(`
    mutation OnboardUserSimple($firstName: String!, $lastName: String!, $email: String!, $contactPhoneNumber: String!, $activityPhoneNumber: String!, $timeZone: String!, $leadType: String, $specialistId: Int!, $Id_Ehr: String!, $isTestUser: Boolean!) {
  createAccount(
    data: {firstName: $firstName, lastName: $lastName, email: $email, contactPhoneNumber: $contactPhoneNumber, activityPhoneNumber: $activityPhoneNumber, timeZone: $timeZone, specialistId: $specialistId, isTestUser: $isTestUser, leadType: $leadType, Id_Ehr: $Id_Ehr}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  OnboardUserSimpleMutation,
  OnboardUserSimpleMutationVariables
>;
export const GetAddUserPopupSpecialistsDocument = new TypedDocumentString(`
    query GetAddUserPopupSpecialists {
  specialists {
    id
    firstName
  }
}
    `) as unknown as TypedDocumentString<
  GetAddUserPopupSpecialistsQuery,
  GetAddUserPopupSpecialistsQueryVariables
>;
export const GetAllUsersDocument = new TypedDocumentString(`
    query GetAllUsers($skip: Int, $take: Int, $isTestUser: Boolean) {
  accounts(skip: $skip, take: $take, isTestUser: $isTestUser) {
    accounts {
      ...AccountFullInfo
      nextScheduledCall
    }
    total
  }
}
    fragment AccountBasicInfo on Account {
  id
  firstName
  lastName
  deletedAt
  timeZone
  summary
  leadType
  Id_Ehr
  contactPhoneNumber
  activityPhoneNumber
  bdlProgramStartOn
  bdlProgramEndOn
  latest_program_type
  latest_program_type_status
  programStartOn
  programEndOn
}
fragment UserInfo on User {
  id
  firstName
  lastName
  email
  isTestUser
}
fragment SpecialistInfo on User {
  id
  firstName
  lastName
  email
}
fragment PlaylistBasicInfo on Playlist {
  id
  title
  startOn
  endOn
  isActive
}
fragment PlaylistWithProgram on Playlist {
  ...PlaylistBasicInfo
  program {
    id
  }
}
fragment AccountFullInfo on Account {
  ...AccountBasicInfo
  specialist {
    ...SpecialistInfo
  }
  user {
    ...UserInfo
  }
  playlists {
    ...PlaylistWithProgram
  }
  latestProgram {
    id
    program_type
    start_date
    end_date
  }
}`) as unknown as TypedDocumentString<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const GetFilteredUsersDocument = new TypedDocumentString(`
    query GetFilteredUsers($skip: Int, $take: Int, $isTestUser: Boolean, $specialistId: [Int!], $ProgramType: [String!], $sortColumn: String, $sortOrder: SortOrder, $name: String) {
  accountsWithFilter(
    skip: $skip
    take: $take
    isTestUser: $isTestUser
    specialistId: $specialistId
    ProgramType: $ProgramType
    sortColumn: $sortColumn
    sortOrder: $sortOrder
    name: $name
  ) {
    accounts {
      ...AccountFullInfo
      nextScheduledCall
    }
    total
  }
}
    fragment AccountBasicInfo on Account {
  id
  firstName
  lastName
  deletedAt
  timeZone
  summary
  leadType
  Id_Ehr
  contactPhoneNumber
  activityPhoneNumber
  bdlProgramStartOn
  bdlProgramEndOn
  latest_program_type
  latest_program_type_status
  programStartOn
  programEndOn
}
fragment UserInfo on User {
  id
  firstName
  lastName
  email
  isTestUser
}
fragment SpecialistInfo on User {
  id
  firstName
  lastName
  email
}
fragment PlaylistBasicInfo on Playlist {
  id
  title
  startOn
  endOn
  isActive
}
fragment PlaylistWithProgram on Playlist {
  ...PlaylistBasicInfo
  program {
    id
  }
}
fragment AccountFullInfo on Account {
  ...AccountBasicInfo
  specialist {
    ...SpecialistInfo
  }
  user {
    ...UserInfo
  }
  playlists {
    ...PlaylistWithProgram
  }
  latestProgram {
    id
    program_type
    start_date
    end_date
  }
}`) as unknown as TypedDocumentString<GetFilteredUsersQuery, GetFilteredUsersQueryVariables>;
export const GetDeactivatedUsersDocument = new TypedDocumentString(`
    query GetDeactivatedUsers($skip: Int, $take: Int) {
  deactivatedAccounts(skip: $skip, take: $take) {
    deactivatedAccounts {
      id
      firstName
      lastName
      deletedAt
      createdOn
    }
    totalDeactivatedCount
  }
}
    `) as unknown as TypedDocumentString<
  GetDeactivatedUsersQuery,
  GetDeactivatedUsersQueryVariables
>;
